/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Eunice Guest House
 * Eunice Guest House API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AddGuestsToBooking200,
  Amenity,
  AmenityRequest,
  AssignRoleToUser200,
  BookingDetails,
  BookingRequest,
  CreateAmenity200,
  CreateBooking200,
  CreateGroupBooking200,
  CreateGuestHouse200,
  CreateGuestInfo200,
  CreateRate200,
  CreateRoom200,
  CreateServiceAddOn200,
  CreateServiceBreakdown200,
  CreateUser200,
  DeleteAmenity200,
  DeleteBooking200,
  DeleteGuestHouse200,
  DeleteGuestInfo200,
  DeleteImage200,
  DeleteRate200,
  DeleteRoom200,
  DeleteServiceAddOn200,
  DeleteServiceBreakdown200,
  DeleteUser200,
  DepartmentDto,
  DownloadTemplate1200,
  DownloadTemplate1Params,
  DownloadTemplate200,
  FoodItemCategoryDto,
  ForgotPassword200,
  ForgotPasswordRequest,
  FreeIPAUserCreateRequest,
  GetAllAmenitiesParams,
  GetAllBookingsParams,
  GetAllGuestHousesParams,
  GetAllGuestInfoParams,
  GetAllRatesParams,
  GetAllRequestsForMealsAdminParams,
  GetAllRoomsParams,
  GetAllServiceAddOnsParams,
  GetAllServiceBreakdownsParams,
  GetAllUsersParams,
  GetApprovalAccess200,
  GetApprovedHodApprovalsParams,
  GetAvailableRoomsParams,
  GetBookingGuests200,
  GetDepartmentsParams,
  GetFoodItemsParams,
  GetGuestCategoriesParams,
  GetGuestHouseImagesParams,
  GetMealPlansParams,
  GetMyRequestsParams,
  GetPendingDashboardCounts200Item,
  GetPendingHodApprovalsParams,
  GetPriceConfigurationsParams,
  GetRejectedHodApprovalsParams,
  GetServiceTypesParams,
  GetTracker200Item,
  GetUploadHistory200,
  GetUploadHistoryParams,
  GetUserById200,
  GetUsersByRole200,
  Guest,
  GuestCategoryDto,
  GuestHouseImageResponse,
  GuestHouseRequest,
  GuestHouseResponse,
  GuestInfo,
  GuestInfoRequest,
  GuestInformationDTO,
  GuestRequest,
  InitiateRff200,
  JsonNode,
  JwtAuthenticationResponse,
  LoginRequest,
  MealApprovalDecisionRequest,
  MealAttachmentUploadResponse,
  MealFoodItemDto,
  MealInvoiceRequest,
  MealInvoiceResponse,
  MealPlanDto,
  MealRequestParticipantPayload,
  MealRequestResponse,
  MealRffBudgetLineResponse,
  MealRffInitiateRequest,
  MealRffResponse,
  PagedResponseAmenity,
  PagedResponseBookingDetails,
  PagedResponseGuestHouseImageResponse,
  PagedResponseGuestHouseResponse,
  PagedResponseGuestInfo,
  PagedResponseMealRequestResponse,
  PagedResponseRateResponse,
  PagedResponseRoomResponse,
  PagedResponseServiceAddOnResponse,
  PagedResponseServiceBreakDownResponse,
  PagedResponseUserResponseDto,
  PasswordUpdateRequest,
  PaymentRequest,
  PaymentResponse,
  PaymentSummaryDTO,
  PriceConfigurationDto,
  PriceDTO,
  RateRequest,
  RateResponse,
  RemoveGuestFromBooking200,
  RequestUnitSearchResultDto,
  ResetPassword200,
  ResetPasswordRequest,
  RoomRequest,
  RoomResponse,
  SearchParticipantsParams,
  SearchRequestUnitsForEmergencyRequestsParams,
  SearchUsersByName200,
  SearchUsersByNameParams,
  SearchWorkflowApproverStaffParams,
  ServiceAddOnRequest,
  ServiceAddOnResponse,
  ServiceBreakDownResponse,
  ServiceBreakdownRequest,
  ServiceTypeDto,
  SignUpRequest,
  Signup200,
  SignupFreeIPAUser200,
  TestFreeIPA200,
  ToggleUserStatusParams,
  UpdateBooking200,
  UpdateGuestHouseImage200,
  UpdateGuestHouseImageBody,
  UpdateGuestHouseImageParams,
  UpdatePassword200,
  UpdateUser200,
  UploadAttachmentBody,
  UploadBookings200,
  UploadBookingsBody,
  UploadBookingsFromFile200,
  UploadBookingsFromFileBody,
  UploadBookingsFromFileParams,
  UploadGuestHouseImage200,
  UploadGuestHouseImageBody,
  UploadGuestHouseImageParams,
  UploadGuests200,
  UploadGuestsBody,
  UploadGuestsFromFile200,
  UploadGuestsFromFileBody,
  UploadRates200,
  UploadRatesBody,
  UploadRooms200,
  UploadRoomsBody,
  UploadRoomsFromFile200,
  UploadRoomsFromFileBody,
  UploadServices200,
  UploadServicesBody,
  UserCreateDto,
  UserSummary,
  UserUpdateDto,
  ValidateFile200,
  ValidateFileBody,
  WorkflowApproverSearchResultDto,
  WorkflowConfigurationDto
} from './models';





export const getUserById = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserById200>> => {
    
    
    return axios.default.get(
      `/api/users/${userId}`,options
    );
  }




export const getGetUserByIdQueryKey = (userId?: number,) => {
    return [
    `/api/users/${userId}`
    ] as const;
    }

    
export const getGetUserByIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserById>>, TError = AxiosError<unknown>>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserByIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({ signal }) => getUserById(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserById>>>
export type GetUserByIdQueryError = AxiosError<unknown>


export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = AxiosError<unknown>>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserByIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateUser = (
    userId: number,
    userUpdateDto: UserUpdateDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateUser200>> => {
    
    
    return axios.default.put(
      `/api/users/${userId}`,
      userUpdateDto,options
    );
  }



export const getUpdateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: number;data: UserUpdateDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: number;data: UserUpdateDto}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {userId: number;data: UserUpdateDto}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUser(userId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UserUpdateDto
    export type UpdateUserMutationError = AxiosError<unknown>

    export const useUpdateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: number;data: UserUpdateDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {userId: number;data: UserUpdateDto},
        TContext
      > => {

      const mutationOptions = getUpdateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteUser = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteUser200>> => {
    
    
    return axios.default.delete(
      `/api/users/${userId}`,options
    );
  }



export const getDeleteUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: number}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUser(userId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = AxiosError<unknown>

    export const useDeleteUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {userId: number},
        TContext
      > => {

      const mutationOptions = getDeleteUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getUserStatus = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.default.get(
      `/api/users/${userId}/status`,options
    );
  }




export const getGetUserStatusQueryKey = (userId?: number,) => {
    return [
    `/api/users/${userId}/status`
    ] as const;
    }

    
export const getGetUserStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStatusQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatus>>> = ({ signal }) => getUserStatus(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStatus>>>
export type GetUserStatusQueryError = AxiosError<unknown>


export function useGetUserStatus<TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserStatus<TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserStatus<TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserStatus<TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserStatusQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const toggleUserStatus = (
    userId: number,
    params: ToggleUserStatusParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.put(
      `/api/users/${userId}/status`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getToggleUserStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleUserStatus>>, TError,{userId: number;params: ToggleUserStatusParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof toggleUserStatus>>, TError,{userId: number;params: ToggleUserStatusParams}, TContext> => {

const mutationKey = ['toggleUserStatus'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleUserStatus>>, {userId: number;params: ToggleUserStatusParams}> = (props) => {
          const {userId,params} = props ?? {};

          return  toggleUserStatus(userId,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleUserStatusMutationResult = NonNullable<Awaited<ReturnType<typeof toggleUserStatus>>>
    
    export type ToggleUserStatusMutationError = AxiosError<unknown>

    export const useToggleUserStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleUserStatus>>, TError,{userId: number;params: ToggleUserStatusParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleUserStatus>>,
        TError,
        {userId: number;params: ToggleUserStatusParams},
        TContext
      > => {

      const mutationOptions = getToggleUserStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const assignRoleToUser = (
    userId: number,
    roleId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssignRoleToUser200>> => {
    
    
    return axios.default.put(
      `/api/users/${userId}/role/${roleId}`,undefined,options
    );
  }



export const getAssignRoleToUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignRoleToUser>>, TError,{userId: number;roleId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof assignRoleToUser>>, TError,{userId: number;roleId: number}, TContext> => {

const mutationKey = ['assignRoleToUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignRoleToUser>>, {userId: number;roleId: number}> = (props) => {
          const {userId,roleId} = props ?? {};

          return  assignRoleToUser(userId,roleId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignRoleToUserMutationResult = NonNullable<Awaited<ReturnType<typeof assignRoleToUser>>>
    
    export type AssignRoleToUserMutationError = AxiosError<unknown>

    export const useAssignRoleToUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignRoleToUser>>, TError,{userId: number;roleId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignRoleToUser>>,
        TError,
        {userId: number;roleId: number},
        TContext
      > => {

      const mutationOptions = getAssignRoleToUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updatePassword = (
    userId: number,
    passwordUpdateRequest: PasswordUpdateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdatePassword200>> => {
    
    
    return axios.default.put(
      `/api/users/${userId}/password`,
      passwordUpdateRequest,options
    );
  }



export const getUpdatePasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,{userId: number;data: PasswordUpdateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,{userId: number;data: PasswordUpdateRequest}, TContext> => {

const mutationKey = ['updatePassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePassword>>, {userId: number;data: PasswordUpdateRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  updatePassword(userId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updatePassword>>>
    export type UpdatePasswordMutationBody = PasswordUpdateRequest
    export type UpdatePasswordMutationError = AxiosError<unknown>

    export const useUpdatePassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,{userId: number;data: PasswordUpdateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePassword>>,
        TError,
        {userId: number;data: PasswordUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deactivateUser = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.put(
      `/api/users/${userId}/deactivate`,undefined,{
    ...options,}
    );
  }



export const getDeactivateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{userId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{userId: number}, TContext> => {

const mutationKey = ['deactivateUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateUser>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  deactivateUser(userId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateUser>>>
    
    export type DeactivateUserMutationError = AxiosError<unknown>

    export const useDeactivateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{userId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateUser>>,
        TError,
        {userId: number},
        TContext
      > => {

      const mutationOptions = getDeactivateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const activateUser = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.put(
      `/api/users/${userId}/activate`,undefined,{
    ...options,}
    );
  }



export const getActivateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateUser>>, TError,{userId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof activateUser>>, TError,{userId: number}, TContext> => {

const mutationKey = ['activateUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateUser>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  activateUser(userId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof activateUser>>>
    
    export type ActivateUserMutationError = AxiosError<unknown>

    export const useActivateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateUser>>, TError,{userId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateUser>>,
        TError,
        {userId: number},
        TContext
      > => {

      const mutationOptions = getActivateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates an existing draft meal request owned by the authenticated user.
 * @summary Update a draft meal request
 */
export const updateDraft = (
    requestId: number,
    jsonNode: JsonNode, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.put(
      `/api/meals/requests/${requestId}/draft`,
      jsonNode,options
    );
  }



export const getUpdateDraftMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraft>>, TError,{requestId: number;data: JsonNode}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraft>>, TError,{requestId: number;data: JsonNode}, TContext> => {

const mutationKey = ['updateDraft'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraft>>, {requestId: number;data: JsonNode}> = (props) => {
          const {requestId,data} = props ?? {};

          return  updateDraft(requestId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraft>>>
    export type UpdateDraftMutationBody = JsonNode
    export type UpdateDraftMutationError = AxiosError<unknown>

    /**
 * @summary Update a draft meal request
 */
export const useUpdateDraft = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraft>>, TError,{requestId: number;data: JsonNode}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDraft>>,
        TError,
        {requestId: number;data: JsonNode},
        TContext
      > => {

      const mutationOptions = getUpdateDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes an existing draft meal request owned by the authenticated user.
 * @summary Delete a draft meal request
 */
export const deleteDraft = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/meals/requests/${requestId}/draft`,options
    );
  }



export const getDeleteDraftMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraft>>, TError,{requestId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraft>>, TError,{requestId: number}, TContext> => {

const mutationKey = ['deleteDraft'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraft>>, {requestId: number}> = (props) => {
          const {requestId} = props ?? {};

          return  deleteDraft(requestId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraft>>>
    
    export type DeleteDraftMutationError = AxiosError<unknown>

    /**
 * @summary Delete a draft meal request
 */
export const useDeleteDraft = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraft>>, TError,{requestId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraft>>,
        TError,
        {requestId: number},
        TContext
      > => {

      const mutationOptions = getDeleteDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates a stored workflow definition for meals approvals.
 * @summary Update a workflow configuration
 */
export const updateWorkflow = (
    workflowId: number,
    workflowConfigurationDto: WorkflowConfigurationDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkflowConfigurationDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/workflows/${workflowId}`,
      workflowConfigurationDto,options
    );
  }



export const getUpdateWorkflowMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,{workflowId: number;data: WorkflowConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,{workflowId: number;data: WorkflowConfigurationDto}, TContext> => {

const mutationKey = ['updateWorkflow'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflow>>, {workflowId: number;data: WorkflowConfigurationDto}> = (props) => {
          const {workflowId,data} = props ?? {};

          return  updateWorkflow(workflowId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflow>>>
    export type UpdateWorkflowMutationBody = WorkflowConfigurationDto
    export type UpdateWorkflowMutationError = AxiosError<unknown>

    /**
 * @summary Update a workflow configuration
 */
export const useUpdateWorkflow = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,{workflowId: number;data: WorkflowConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflow>>,
        TError,
        {workflowId: number;data: WorkflowConfigurationDto},
        TContext
      > => {

      const mutationOptions = getUpdateWorkflowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the details of a single meals service type.
 * @summary Get one service type
 */
export const getServiceTypeById = (
    serviceTypeId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceTypeDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/service-types/${serviceTypeId}`,options
    );
  }




export const getGetServiceTypeByIdQueryKey = (serviceTypeId?: number,) => {
    return [
    `/api/meals/config/service-types/${serviceTypeId}`
    ] as const;
    }

    
export const getGetServiceTypeByIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceTypeById>>, TError = AxiosError<unknown>>(serviceTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceTypeByIdQueryKey(serviceTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceTypeById>>> = ({ signal }) => getServiceTypeById(serviceTypeId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(serviceTypeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceTypeByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceTypeById>>>
export type GetServiceTypeByIdQueryError = AxiosError<unknown>


export function useGetServiceTypeById<TData = Awaited<ReturnType<typeof getServiceTypeById>>, TError = AxiosError<unknown>>(
 serviceTypeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceTypeById>>,
          TError,
          Awaited<ReturnType<typeof getServiceTypeById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceTypeById<TData = Awaited<ReturnType<typeof getServiceTypeById>>, TError = AxiosError<unknown>>(
 serviceTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceTypeById>>,
          TError,
          Awaited<ReturnType<typeof getServiceTypeById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceTypeById<TData = Awaited<ReturnType<typeof getServiceTypeById>>, TError = AxiosError<unknown>>(
 serviceTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one service type
 */

export function useGetServiceTypeById<TData = Awaited<ReturnType<typeof getServiceTypeById>>, TError = AxiosError<unknown>>(
 serviceTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceTypeByIdQueryOptions(serviceTypeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates an existing service type used in the meals module.
 * @summary Update a service type
 */
export const updateServiceType = (
    serviceTypeId: number,
    serviceTypeDto: ServiceTypeDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceTypeDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/service-types/${serviceTypeId}`,
      serviceTypeDto,options
    );
  }



export const getUpdateServiceTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceType>>, TError,{serviceTypeId: number;data: ServiceTypeDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateServiceType>>, TError,{serviceTypeId: number;data: ServiceTypeDto}, TContext> => {

const mutationKey = ['updateServiceType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateServiceType>>, {serviceTypeId: number;data: ServiceTypeDto}> = (props) => {
          const {serviceTypeId,data} = props ?? {};

          return  updateServiceType(serviceTypeId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateServiceTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateServiceType>>>
    export type UpdateServiceTypeMutationBody = ServiceTypeDto
    export type UpdateServiceTypeMutationError = AxiosError<unknown>

    /**
 * @summary Update a service type
 */
export const useUpdateServiceType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceType>>, TError,{serviceTypeId: number;data: ServiceTypeDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateServiceType>>,
        TError,
        {serviceTypeId: number;data: ServiceTypeDto},
        TContext
      > => {

      const mutationOptions = getUpdateServiceTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the details of a single meals price configuration.
 * @summary Get one meal price configuration
 */
export const getPriceConfigurationById = (
    priceConfigurationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceConfigurationDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/price-configurations/${priceConfigurationId}`,options
    );
  }




export const getGetPriceConfigurationByIdQueryKey = (priceConfigurationId?: number,) => {
    return [
    `/api/meals/config/price-configurations/${priceConfigurationId}`
    ] as const;
    }

    
export const getGetPriceConfigurationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getPriceConfigurationById>>, TError = AxiosError<unknown>>(priceConfigurationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurationById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriceConfigurationByIdQueryKey(priceConfigurationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPriceConfigurationById>>> = ({ signal }) => getPriceConfigurationById(priceConfigurationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(priceConfigurationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriceConfigurationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPriceConfigurationById>>>
export type GetPriceConfigurationByIdQueryError = AxiosError<unknown>


export function useGetPriceConfigurationById<TData = Awaited<ReturnType<typeof getPriceConfigurationById>>, TError = AxiosError<unknown>>(
 priceConfigurationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getPriceConfigurationById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceConfigurationById<TData = Awaited<ReturnType<typeof getPriceConfigurationById>>, TError = AxiosError<unknown>>(
 priceConfigurationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getPriceConfigurationById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceConfigurationById<TData = Awaited<ReturnType<typeof getPriceConfigurationById>>, TError = AxiosError<unknown>>(
 priceConfigurationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurationById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal price configuration
 */

export function useGetPriceConfigurationById<TData = Awaited<ReturnType<typeof getPriceConfigurationById>>, TError = AxiosError<unknown>>(
 priceConfigurationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurationById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriceConfigurationByIdQueryOptions(priceConfigurationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates an existing meals price configuration.
 * @summary Update a meal price configuration
 */
export const updatePriceConfiguration = (
    priceConfigurationId: number,
    priceConfigurationDto: PriceConfigurationDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceConfigurationDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/price-configurations/${priceConfigurationId}`,
      priceConfigurationDto,options
    );
  }



export const getUpdatePriceConfigurationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceConfiguration>>, TError,{priceConfigurationId: number;data: PriceConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePriceConfiguration>>, TError,{priceConfigurationId: number;data: PriceConfigurationDto}, TContext> => {

const mutationKey = ['updatePriceConfiguration'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePriceConfiguration>>, {priceConfigurationId: number;data: PriceConfigurationDto}> = (props) => {
          const {priceConfigurationId,data} = props ?? {};

          return  updatePriceConfiguration(priceConfigurationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updatePriceConfiguration>>>
    export type UpdatePriceConfigurationMutationBody = PriceConfigurationDto
    export type UpdatePriceConfigurationMutationError = AxiosError<unknown>

    /**
 * @summary Update a meal price configuration
 */
export const useUpdatePriceConfiguration = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceConfiguration>>, TError,{priceConfigurationId: number;data: PriceConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePriceConfiguration>>,
        TError,
        {priceConfigurationId: number;data: PriceConfigurationDto},
        TContext
      > => {

      const mutationOptions = getUpdatePriceConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Permanently deletes a configured price line when it is no longer referenced.
 * @summary Delete a meal price configuration
 */
export const deletePriceConfiguration = (
    priceConfigurationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/meals/config/price-configurations/${priceConfigurationId}`,options
    );
  }



export const getDeletePriceConfigurationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deletePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext> => {

const mutationKey = ['deletePriceConfiguration'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePriceConfiguration>>, {priceConfigurationId: number}> = (props) => {
          const {priceConfigurationId} = props ?? {};

          return  deletePriceConfiguration(priceConfigurationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePriceConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof deletePriceConfiguration>>>
    
    export type DeletePriceConfigurationMutationError = AxiosError<unknown>

    /**
 * @summary Delete a meal price configuration
 */
export const useDeletePriceConfiguration = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePriceConfiguration>>,
        TError,
        {priceConfigurationId: number},
        TContext
      > => {

      const mutationOptions = getDeletePriceConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks an archived price configuration as active again.
 * @summary Restore a meal price configuration
 */
export const restorePriceConfiguration = (
    priceConfigurationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceConfigurationDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/price-configurations/${priceConfigurationId}/restore`,undefined,options
    );
  }



export const getRestorePriceConfigurationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof restorePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext> => {

const mutationKey = ['restorePriceConfiguration'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restorePriceConfiguration>>, {priceConfigurationId: number}> = (props) => {
          const {priceConfigurationId} = props ?? {};

          return  restorePriceConfiguration(priceConfigurationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RestorePriceConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof restorePriceConfiguration>>>
    
    export type RestorePriceConfigurationMutationError = AxiosError<unknown>

    /**
 * @summary Restore a meal price configuration
 */
export const useRestorePriceConfiguration = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restorePriceConfiguration>>,
        TError,
        {priceConfigurationId: number},
        TContext
      > => {

      const mutationOptions = getRestorePriceConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks a price configuration as inactive without deleting it from history.
 * @summary Archive a meal price configuration
 */
export const archivePriceConfiguration = (
    priceConfigurationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceConfigurationDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/price-configurations/${priceConfigurationId}/archive`,undefined,options
    );
  }



export const getArchivePriceConfigurationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archivePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof archivePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext> => {

const mutationKey = ['archivePriceConfiguration'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archivePriceConfiguration>>, {priceConfigurationId: number}> = (props) => {
          const {priceConfigurationId} = props ?? {};

          return  archivePriceConfiguration(priceConfigurationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchivePriceConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof archivePriceConfiguration>>>
    
    export type ArchivePriceConfigurationMutationError = AxiosError<unknown>

    /**
 * @summary Archive a meal price configuration
 */
export const useArchivePriceConfiguration = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archivePriceConfiguration>>, TError,{priceConfigurationId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archivePriceConfiguration>>,
        TError,
        {priceConfigurationId: number},
        TContext
      > => {

      const mutationOptions = getArchivePriceConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the details of a single meals meal plan.
 * @summary Get one meal plan
 */
export const getMealPlanById = (
    mealPlanId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealPlanDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/meal-plans/${mealPlanId}`,options
    );
  }




export const getGetMealPlanByIdQueryKey = (mealPlanId?: number,) => {
    return [
    `/api/meals/config/meal-plans/${mealPlanId}`
    ] as const;
    }

    
export const getGetMealPlanByIdQueryOptions = <TData = Awaited<ReturnType<typeof getMealPlanById>>, TError = AxiosError<unknown>>(mealPlanId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlanById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMealPlanByIdQueryKey(mealPlanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMealPlanById>>> = ({ signal }) => getMealPlanById(mealPlanId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(mealPlanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMealPlanById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMealPlanByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMealPlanById>>>
export type GetMealPlanByIdQueryError = AxiosError<unknown>


export function useGetMealPlanById<TData = Awaited<ReturnType<typeof getMealPlanById>>, TError = AxiosError<unknown>>(
 mealPlanId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlanById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMealPlanById>>,
          TError,
          Awaited<ReturnType<typeof getMealPlanById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMealPlanById<TData = Awaited<ReturnType<typeof getMealPlanById>>, TError = AxiosError<unknown>>(
 mealPlanId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlanById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMealPlanById>>,
          TError,
          Awaited<ReturnType<typeof getMealPlanById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMealPlanById<TData = Awaited<ReturnType<typeof getMealPlanById>>, TError = AxiosError<unknown>>(
 mealPlanId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlanById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal plan
 */

export function useGetMealPlanById<TData = Awaited<ReturnType<typeof getMealPlanById>>, TError = AxiosError<unknown>>(
 mealPlanId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlanById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMealPlanByIdQueryOptions(mealPlanId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates an existing meal plan used in the meals module.
 * @summary Update a meal plan
 */
export const updateMealPlan = (
    mealPlanId: number,
    mealPlanDto: MealPlanDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealPlanDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/meal-plans/${mealPlanId}`,
      mealPlanDto,options
    );
  }



export const getUpdateMealPlanMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMealPlan>>, TError,{mealPlanId: number;data: MealPlanDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateMealPlan>>, TError,{mealPlanId: number;data: MealPlanDto}, TContext> => {

const mutationKey = ['updateMealPlan'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMealPlan>>, {mealPlanId: number;data: MealPlanDto}> = (props) => {
          const {mealPlanId,data} = props ?? {};

          return  updateMealPlan(mealPlanId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMealPlanMutationResult = NonNullable<Awaited<ReturnType<typeof updateMealPlan>>>
    export type UpdateMealPlanMutationBody = MealPlanDto
    export type UpdateMealPlanMutationError = AxiosError<unknown>

    /**
 * @summary Update a meal plan
 */
export const useUpdateMealPlan = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMealPlan>>, TError,{mealPlanId: number;data: MealPlanDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMealPlan>>,
        TError,
        {mealPlanId: number;data: MealPlanDto},
        TContext
      > => {

      const mutationOptions = getUpdateMealPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Permanently deletes a configured meal plan when it is no longer referenced.
 * @summary Delete a meal plan
 */
export const deleteMealPlan = (
    mealPlanId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/meals/config/meal-plans/${mealPlanId}`,options
    );
  }



export const getDeleteMealPlanMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMealPlan>>, TError,{mealPlanId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMealPlan>>, TError,{mealPlanId: number}, TContext> => {

const mutationKey = ['deleteMealPlan'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMealPlan>>, {mealPlanId: number}> = (props) => {
          const {mealPlanId} = props ?? {};

          return  deleteMealPlan(mealPlanId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMealPlanMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMealPlan>>>
    
    export type DeleteMealPlanMutationError = AxiosError<unknown>

    /**
 * @summary Delete a meal plan
 */
export const useDeleteMealPlan = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMealPlan>>, TError,{mealPlanId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMealPlan>>,
        TError,
        {mealPlanId: number},
        TContext
      > => {

      const mutationOptions = getDeleteMealPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks an archived meal plan as active again.
 * @summary Restore a meal plan
 */
export const restoreMealPlan = (
    mealPlanId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealPlanDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/meal-plans/${mealPlanId}/restore`,undefined,options
    );
  }



export const getRestoreMealPlanMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreMealPlan>>, TError,{mealPlanId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof restoreMealPlan>>, TError,{mealPlanId: number}, TContext> => {

const mutationKey = ['restoreMealPlan'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreMealPlan>>, {mealPlanId: number}> = (props) => {
          const {mealPlanId} = props ?? {};

          return  restoreMealPlan(mealPlanId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RestoreMealPlanMutationResult = NonNullable<Awaited<ReturnType<typeof restoreMealPlan>>>
    
    export type RestoreMealPlanMutationError = AxiosError<unknown>

    /**
 * @summary Restore a meal plan
 */
export const useRestoreMealPlan = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreMealPlan>>, TError,{mealPlanId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreMealPlan>>,
        TError,
        {mealPlanId: number},
        TContext
      > => {

      const mutationOptions = getRestoreMealPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks a meal plan as inactive without deleting it from history.
 * @summary Archive a meal plan
 */
export const archiveMealPlan = (
    mealPlanId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealPlanDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/meal-plans/${mealPlanId}/archive`,undefined,options
    );
  }



export const getArchiveMealPlanMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveMealPlan>>, TError,{mealPlanId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof archiveMealPlan>>, TError,{mealPlanId: number}, TContext> => {

const mutationKey = ['archiveMealPlan'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveMealPlan>>, {mealPlanId: number}> = (props) => {
          const {mealPlanId} = props ?? {};

          return  archiveMealPlan(mealPlanId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveMealPlanMutationResult = NonNullable<Awaited<ReturnType<typeof archiveMealPlan>>>
    
    export type ArchiveMealPlanMutationError = AxiosError<unknown>

    /**
 * @summary Archive a meal plan
 */
export const useArchiveMealPlan = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveMealPlan>>, TError,{mealPlanId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveMealPlan>>,
        TError,
        {mealPlanId: number},
        TContext
      > => {

      const mutationOptions = getArchiveMealPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the details of a single guest category used in the meals pricing model.
 * @summary Get one guest category
 */
export const getGuestCategoryById = (
    guestCategoryId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestCategoryDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/guest-categories/${guestCategoryId}`,options
    );
  }




export const getGetGuestCategoryByIdQueryKey = (guestCategoryId?: number,) => {
    return [
    `/api/meals/config/guest-categories/${guestCategoryId}`
    ] as const;
    }

    
export const getGetGuestCategoryByIdQueryOptions = <TData = Awaited<ReturnType<typeof getGuestCategoryById>>, TError = AxiosError<unknown>>(guestCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategoryById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestCategoryByIdQueryKey(guestCategoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestCategoryById>>> = ({ signal }) => getGuestCategoryById(guestCategoryId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(guestCategoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestCategoryById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestCategoryByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestCategoryById>>>
export type GetGuestCategoryByIdQueryError = AxiosError<unknown>


export function useGetGuestCategoryById<TData = Awaited<ReturnType<typeof getGuestCategoryById>>, TError = AxiosError<unknown>>(
 guestCategoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategoryById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getGuestCategoryById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestCategoryById<TData = Awaited<ReturnType<typeof getGuestCategoryById>>, TError = AxiosError<unknown>>(
 guestCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategoryById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getGuestCategoryById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestCategoryById<TData = Awaited<ReturnType<typeof getGuestCategoryById>>, TError = AxiosError<unknown>>(
 guestCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategoryById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one guest category
 */

export function useGetGuestCategoryById<TData = Awaited<ReturnType<typeof getGuestCategoryById>>, TError = AxiosError<unknown>>(
 guestCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategoryById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestCategoryByIdQueryOptions(guestCategoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates an existing guest category used in normalized meal pricing.
 * @summary Update a guest category
 */
export const updateGuestCategory = (
    guestCategoryId: number,
    guestCategoryDto: GuestCategoryDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestCategoryDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/guest-categories/${guestCategoryId}`,
      guestCategoryDto,options
    );
  }



export const getUpdateGuestCategoryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestCategory>>, TError,{guestCategoryId: number;data: GuestCategoryDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateGuestCategory>>, TError,{guestCategoryId: number;data: GuestCategoryDto}, TContext> => {

const mutationKey = ['updateGuestCategory'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGuestCategory>>, {guestCategoryId: number;data: GuestCategoryDto}> = (props) => {
          const {guestCategoryId,data} = props ?? {};

          return  updateGuestCategory(guestCategoryId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGuestCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateGuestCategory>>>
    export type UpdateGuestCategoryMutationBody = GuestCategoryDto
    export type UpdateGuestCategoryMutationError = AxiosError<unknown>

    /**
 * @summary Update a guest category
 */
export const useUpdateGuestCategory = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestCategory>>, TError,{guestCategoryId: number;data: GuestCategoryDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGuestCategory>>,
        TError,
        {guestCategoryId: number;data: GuestCategoryDto},
        TContext
      > => {

      const mutationOptions = getUpdateGuestCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the details of a single configured food item.
 * @summary Get one meal food item
 */
export const getFoodItemById = (
    foodItemId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealFoodItemDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/food-items/${foodItemId}`,options
    );
  }




export const getGetFoodItemByIdQueryKey = (foodItemId?: number,) => {
    return [
    `/api/meals/config/food-items/${foodItemId}`
    ] as const;
    }

    
export const getGetFoodItemByIdQueryOptions = <TData = Awaited<ReturnType<typeof getFoodItemById>>, TError = AxiosError<unknown>>(foodItemId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItemById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFoodItemByIdQueryKey(foodItemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFoodItemById>>> = ({ signal }) => getFoodItemById(foodItemId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(foodItemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFoodItemById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFoodItemByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFoodItemById>>>
export type GetFoodItemByIdQueryError = AxiosError<unknown>


export function useGetFoodItemById<TData = Awaited<ReturnType<typeof getFoodItemById>>, TError = AxiosError<unknown>>(
 foodItemId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItemById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFoodItemById>>,
          TError,
          Awaited<ReturnType<typeof getFoodItemById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFoodItemById<TData = Awaited<ReturnType<typeof getFoodItemById>>, TError = AxiosError<unknown>>(
 foodItemId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItemById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFoodItemById>>,
          TError,
          Awaited<ReturnType<typeof getFoodItemById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFoodItemById<TData = Awaited<ReturnType<typeof getFoodItemById>>, TError = AxiosError<unknown>>(
 foodItemId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItemById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal food item
 */

export function useGetFoodItemById<TData = Awaited<ReturnType<typeof getFoodItemById>>, TError = AxiosError<unknown>>(
 foodItemId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItemById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFoodItemByIdQueryOptions(foodItemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates a configured food item used on meal plans.
 * @summary Update a meal food item
 */
export const updateFoodItem = (
    foodItemId: number,
    mealFoodItemDto: MealFoodItemDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealFoodItemDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/food-items/${foodItemId}`,
      mealFoodItemDto,options
    );
  }



export const getUpdateFoodItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFoodItem>>, TError,{foodItemId: number;data: MealFoodItemDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateFoodItem>>, TError,{foodItemId: number;data: MealFoodItemDto}, TContext> => {

const mutationKey = ['updateFoodItem'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFoodItem>>, {foodItemId: number;data: MealFoodItemDto}> = (props) => {
          const {foodItemId,data} = props ?? {};

          return  updateFoodItem(foodItemId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFoodItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateFoodItem>>>
    export type UpdateFoodItemMutationBody = MealFoodItemDto
    export type UpdateFoodItemMutationError = AxiosError<unknown>

    /**
 * @summary Update a meal food item
 */
export const useUpdateFoodItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFoodItem>>, TError,{foodItemId: number;data: MealFoodItemDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFoodItem>>,
        TError,
        {foodItemId: number;data: MealFoodItemDto},
        TContext
      > => {

      const mutationOptions = getUpdateFoodItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Permanently deletes a configured food item from the meals module.
 * @summary Delete a meal food item
 */
export const deleteFoodItem = (
    foodItemId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/meals/config/food-items/${foodItemId}`,options
    );
  }



export const getDeleteFoodItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFoodItem>>, TError,{foodItemId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFoodItem>>, TError,{foodItemId: number}, TContext> => {

const mutationKey = ['deleteFoodItem'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFoodItem>>, {foodItemId: number}> = (props) => {
          const {foodItemId} = props ?? {};

          return  deleteFoodItem(foodItemId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFoodItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFoodItem>>>
    
    export type DeleteFoodItemMutationError = AxiosError<unknown>

    /**
 * @summary Delete a meal food item
 */
export const useDeleteFoodItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFoodItem>>, TError,{foodItemId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFoodItem>>,
        TError,
        {foodItemId: number},
        TContext
      > => {

      const mutationOptions = getDeleteFoodItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks an archived food item as active again.
 * @summary Restore a meal food item
 */
export const restoreFoodItem = (
    foodItemId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealFoodItemDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/food-items/${foodItemId}/restore`,undefined,options
    );
  }



export const getRestoreFoodItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreFoodItem>>, TError,{foodItemId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof restoreFoodItem>>, TError,{foodItemId: number}, TContext> => {

const mutationKey = ['restoreFoodItem'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreFoodItem>>, {foodItemId: number}> = (props) => {
          const {foodItemId} = props ?? {};

          return  restoreFoodItem(foodItemId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RestoreFoodItemMutationResult = NonNullable<Awaited<ReturnType<typeof restoreFoodItem>>>
    
    export type RestoreFoodItemMutationError = AxiosError<unknown>

    /**
 * @summary Restore a meal food item
 */
export const useRestoreFoodItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreFoodItem>>, TError,{foodItemId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreFoodItem>>,
        TError,
        {foodItemId: number},
        TContext
      > => {

      const mutationOptions = getRestoreFoodItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks a food item as inactive without deleting it from history.
 * @summary Archive a meal food item
 */
export const archiveFoodItem = (
    foodItemId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealFoodItemDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/food-items/${foodItemId}/archive`,undefined,options
    );
  }



export const getArchiveFoodItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveFoodItem>>, TError,{foodItemId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof archiveFoodItem>>, TError,{foodItemId: number}, TContext> => {

const mutationKey = ['archiveFoodItem'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveFoodItem>>, {foodItemId: number}> = (props) => {
          const {foodItemId} = props ?? {};

          return  archiveFoodItem(foodItemId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveFoodItemMutationResult = NonNullable<Awaited<ReturnType<typeof archiveFoodItem>>>
    
    export type ArchiveFoodItemMutationError = AxiosError<unknown>

    /**
 * @summary Archive a meal food item
 */
export const useArchiveFoodItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveFoodItem>>, TError,{foodItemId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveFoodItem>>,
        TError,
        {foodItemId: number},
        TContext
      > => {

      const mutationOptions = getArchiveFoodItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the details of a single department used in the meals module.
 * @summary Get one meal department
 */
export const getDepartmentById = (
    departmentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DepartmentDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/departments/${departmentId}`,options
    );
  }




export const getGetDepartmentByIdQueryKey = (departmentId?: number,) => {
    return [
    `/api/meals/config/departments/${departmentId}`
    ] as const;
    }

    
export const getGetDepartmentByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentById>>, TError = AxiosError<unknown>>(departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentByIdQueryKey(departmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentById>>> = ({ signal }) => getDepartmentById(departmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(departmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentById>>>
export type GetDepartmentByIdQueryError = AxiosError<unknown>


export function useGetDepartmentById<TData = Awaited<ReturnType<typeof getDepartmentById>>, TError = AxiosError<unknown>>(
 departmentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentById>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentById<TData = Awaited<ReturnType<typeof getDepartmentById>>, TError = AxiosError<unknown>>(
 departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentById>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentById<TData = Awaited<ReturnType<typeof getDepartmentById>>, TError = AxiosError<unknown>>(
 departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal department
 */

export function useGetDepartmentById<TData = Awaited<ReturnType<typeof getDepartmentById>>, TError = AxiosError<unknown>>(
 departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentByIdQueryOptions(departmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates an existing department used in the meals module.
 * @summary Update a meal department
 */
export const updateDepartment = (
    departmentId: number,
    departmentDto: DepartmentDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DepartmentDto>> => {
    
    
    return axios.default.put(
      `/api/meals/config/departments/${departmentId}`,
      departmentDto,options
    );
  }



export const getUpdateDepartmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{departmentId: number;data: DepartmentDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{departmentId: number;data: DepartmentDto}, TContext> => {

const mutationKey = ['updateDepartment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDepartment>>, {departmentId: number;data: DepartmentDto}> = (props) => {
          const {departmentId,data} = props ?? {};

          return  updateDepartment(departmentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDepartment>>>
    export type UpdateDepartmentMutationBody = DepartmentDto
    export type UpdateDepartmentMutationError = AxiosError<unknown>

    /**
 * @summary Update a meal department
 */
export const useUpdateDepartment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{departmentId: number;data: DepartmentDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDepartment>>,
        TError,
        {departmentId: number;data: DepartmentDto},
        TContext
      > => {

      const mutationOptions = getUpdateDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAllUsers = (
    params?: GetAllUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseUserResponseDto>> => {
    
    
    return axios.default.get(
      `/api/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllUsersQueryKey = (params?: GetAllUsersParams,) => {
    return [
    `/api/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAllUsers>>, TError = AxiosError<unknown>>(params?: GetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) => getAllUsers(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>
export type GetAllUsersQueryError = AxiosError<unknown>


export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = AxiosError<unknown>>(
 params?: GetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = AxiosError<unknown>>(
 params?: GetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = AxiosError<unknown>>(
 params?: GetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createUser = (
    userCreateDto: UserCreateDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateUser200>> => {
    
    
    return axios.default.post(
      `/api/users`,
      userCreateDto,options
    );
  }



export const getCreateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: UserCreateDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: UserCreateDto}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: UserCreateDto}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = UserCreateDto
    export type CreateUserMutationError = AxiosError<unknown>

    export const useCreateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: UserCreateDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: UserCreateDto},
        TContext
      > => {

      const mutationOptions = getCreateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * File validation is handled automatically in new system
 * @deprecated
 * @summary DEPRECATED: Not needed
 */
export const validateFile = (
    entityType: string,
    validateFileBody: ValidateFileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ValidateFile200>> => {
    
    
    return axios.default.post(
      `/api/upload/validate/${entityType}`,
      validateFileBody,options
    );
  }



export const getValidateFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateFile>>, TError,{entityType: string;data: ValidateFileBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof validateFile>>, TError,{entityType: string;data: ValidateFileBody}, TContext> => {

const mutationKey = ['validateFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateFile>>, {entityType: string;data: ValidateFileBody}> = (props) => {
          const {entityType,data} = props ?? {};

          return  validateFile(entityType,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateFileMutationResult = NonNullable<Awaited<ReturnType<typeof validateFile>>>
    export type ValidateFileMutationBody = ValidateFileBody
    export type ValidateFileMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary DEPRECATED: Not needed
 */
export const useValidateFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateFile>>, TError,{entityType: string;data: ValidateFileBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateFile>>,
        TError,
        {entityType: string;data: ValidateFileBody},
        TContext
      > => {

      const mutationOptions = getValidateFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Service uploads not yet implemented
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const uploadServices = (
    uploadServicesBody: UploadServicesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadServices200>> => {
    
    
    return axios.default.post(
      `/api/upload/services`,
      uploadServicesBody,options
    );
  }



export const getUploadServicesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadServices>>, TError,{data: UploadServicesBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadServices>>, TError,{data: UploadServicesBody}, TContext> => {

const mutationKey = ['uploadServices'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadServices>>, {data: UploadServicesBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadServices(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadServicesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadServices>>>
    export type UploadServicesMutationBody = UploadServicesBody
    export type UploadServicesMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const useUploadServices = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadServices>>, TError,{data: UploadServicesBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadServices>>,
        TError,
        {data: UploadServicesBody},
        TContext
      > => {

      const mutationOptions = getUploadServicesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * This endpoint is deprecated. Use /api/room/upload instead
 * @deprecated
 * @summary DEPRECATED: Use /api/room/upload
 */
export const uploadRooms = (
    uploadRoomsBody: UploadRoomsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadRooms200>> => {
    
    
    return axios.default.post(
      `/api/upload/rooms`,
      uploadRoomsBody,options
    );
  }



export const getUploadRoomsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRooms>>, TError,{data: UploadRoomsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadRooms>>, TError,{data: UploadRoomsBody}, TContext> => {

const mutationKey = ['uploadRooms'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadRooms>>, {data: UploadRoomsBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadRooms(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadRoomsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadRooms>>>
    export type UploadRoomsMutationBody = UploadRoomsBody
    export type UploadRoomsMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary DEPRECATED: Use /api/room/upload
 */
export const useUploadRooms = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRooms>>, TError,{data: UploadRoomsBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadRooms>>,
        TError,
        {data: UploadRoomsBody},
        TContext
      > => {

      const mutationOptions = getUploadRoomsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Rate uploads not yet implemented
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const uploadRates = (
    uploadRatesBody: UploadRatesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadRates200>> => {
    
    
    return axios.default.post(
      `/api/upload/rates`,
      uploadRatesBody,options
    );
  }



export const getUploadRatesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRates>>, TError,{data: UploadRatesBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadRates>>, TError,{data: UploadRatesBody}, TContext> => {

const mutationKey = ['uploadRates'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadRates>>, {data: UploadRatesBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadRates(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadRatesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadRates>>>
    export type UploadRatesMutationBody = UploadRatesBody
    export type UploadRatesMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const useUploadRates = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRates>>, TError,{data: UploadRatesBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadRates>>,
        TError,
        {data: UploadRatesBody},
        TContext
      > => {

      const mutationOptions = getUploadRatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * This endpoint is deprecated. Use /api/guest/upload instead
 * @deprecated
 * @summary DEPRECATED: Use /api/guest/upload
 */
export const uploadGuests = (
    uploadGuestsBody: UploadGuestsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadGuests200>> => {
    
    
    return axios.default.post(
      `/api/upload/guests`,
      uploadGuestsBody,options
    );
  }



export const getUploadGuestsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadGuests>>, TError,{data: UploadGuestsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadGuests>>, TError,{data: UploadGuestsBody}, TContext> => {

const mutationKey = ['uploadGuests'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadGuests>>, {data: UploadGuestsBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadGuests(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadGuestsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadGuests>>>
    export type UploadGuestsMutationBody = UploadGuestsBody
    export type UploadGuestsMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary DEPRECATED: Use /api/guest/upload
 */
export const useUploadGuests = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadGuests>>, TError,{data: UploadGuestsBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadGuests>>,
        TError,
        {data: UploadGuestsBody},
        TContext
      > => {

      const mutationOptions = getUploadGuestsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Booking uploads not yet implemented
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const uploadBookings = (
    uploadBookingsBody: UploadBookingsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadBookings200>> => {
    
    
    return axios.default.post(
      `/api/upload/bookings`,
      uploadBookingsBody,options
    );
  }



export const getUploadBookingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadBookings>>, TError,{data: UploadBookingsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadBookings>>, TError,{data: UploadBookingsBody}, TContext> => {

const mutationKey = ['uploadBookings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadBookings>>, {data: UploadBookingsBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadBookings(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadBookingsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadBookings>>>
    export type UploadBookingsMutationBody = UploadBookingsBody
    export type UploadBookingsMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const useUploadBookings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadBookings>>, TError,{data: UploadBookingsBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadBookings>>,
        TError,
        {data: UploadBookingsBody},
        TContext
      > => {

      const mutationOptions = getUploadBookingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateServiceBreakdown = (
    serviceBreakdownRequest: ServiceBreakdownRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceBreakDownResponse>> => {
    
    
    return axios.default.post(
      `/api/servicebreakdown/update`,
      serviceBreakdownRequest,options
    );
  }



export const getUpdateServiceBreakdownMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceBreakdown>>, TError,{data: ServiceBreakdownRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateServiceBreakdown>>, TError,{data: ServiceBreakdownRequest}, TContext> => {

const mutationKey = ['updateServiceBreakdown'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateServiceBreakdown>>, {data: ServiceBreakdownRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateServiceBreakdown(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateServiceBreakdownMutationResult = NonNullable<Awaited<ReturnType<typeof updateServiceBreakdown>>>
    export type UpdateServiceBreakdownMutationBody = ServiceBreakdownRequest
    export type UpdateServiceBreakdownMutationError = AxiosError<unknown>

    export const useUpdateServiceBreakdown = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceBreakdown>>, TError,{data: ServiceBreakdownRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateServiceBreakdown>>,
        TError,
        {data: ServiceBreakdownRequest},
        TContext
      > => {

      const mutationOptions = getUpdateServiceBreakdownMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createServiceBreakdown = (
    serviceBreakdownRequest: ServiceBreakdownRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateServiceBreakdown200>> => {
    
    
    return axios.default.post(
      `/api/servicebreakdown/new`,
      serviceBreakdownRequest,options
    );
  }



export const getCreateServiceBreakdownMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceBreakdown>>, TError,{data: ServiceBreakdownRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createServiceBreakdown>>, TError,{data: ServiceBreakdownRequest}, TContext> => {

const mutationKey = ['createServiceBreakdown'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createServiceBreakdown>>, {data: ServiceBreakdownRequest}> = (props) => {
          const {data} = props ?? {};

          return  createServiceBreakdown(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceBreakdownMutationResult = NonNullable<Awaited<ReturnType<typeof createServiceBreakdown>>>
    export type CreateServiceBreakdownMutationBody = ServiceBreakdownRequest
    export type CreateServiceBreakdownMutationError = AxiosError<unknown>

    export const useCreateServiceBreakdown = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceBreakdown>>, TError,{data: ServiceBreakdownRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createServiceBreakdown>>,
        TError,
        {data: ServiceBreakdownRequest},
        TContext
      > => {

      const mutationOptions = getCreateServiceBreakdownMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateServiceAddOn = (
    serviceAddOnRequest: ServiceAddOnRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceAddOnResponse>> => {
    
    
    return axios.default.post(
      `/api/service-add-on/update`,
      serviceAddOnRequest,options
    );
  }



export const getUpdateServiceAddOnMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceAddOn>>, TError,{data: ServiceAddOnRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateServiceAddOn>>, TError,{data: ServiceAddOnRequest}, TContext> => {

const mutationKey = ['updateServiceAddOn'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateServiceAddOn>>, {data: ServiceAddOnRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateServiceAddOn(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateServiceAddOnMutationResult = NonNullable<Awaited<ReturnType<typeof updateServiceAddOn>>>
    export type UpdateServiceAddOnMutationBody = ServiceAddOnRequest
    export type UpdateServiceAddOnMutationError = AxiosError<unknown>

    export const useUpdateServiceAddOn = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceAddOn>>, TError,{data: ServiceAddOnRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateServiceAddOn>>,
        TError,
        {data: ServiceAddOnRequest},
        TContext
      > => {

      const mutationOptions = getUpdateServiceAddOnMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createServiceAddOn = (
    serviceAddOnRequest: ServiceAddOnRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateServiceAddOn200>> => {
    
    
    return axios.default.post(
      `/api/service-add-on/new`,
      serviceAddOnRequest,options
    );
  }



export const getCreateServiceAddOnMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAddOn>>, TError,{data: ServiceAddOnRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createServiceAddOn>>, TError,{data: ServiceAddOnRequest}, TContext> => {

const mutationKey = ['createServiceAddOn'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createServiceAddOn>>, {data: ServiceAddOnRequest}> = (props) => {
          const {data} = props ?? {};

          return  createServiceAddOn(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceAddOnMutationResult = NonNullable<Awaited<ReturnType<typeof createServiceAddOn>>>
    export type CreateServiceAddOnMutationBody = ServiceAddOnRequest
    export type CreateServiceAddOnMutationError = AxiosError<unknown>

    export const useCreateServiceAddOn = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAddOn>>, TError,{data: ServiceAddOnRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createServiceAddOn>>,
        TError,
        {data: ServiceAddOnRequest},
        TContext
      > => {

      const mutationOptions = getCreateServiceAddOnMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Bulk upload room information from CSV or Excel file
 * @summary Upload room data
 */
export const uploadRoomsFromFile = (
    uploadRoomsFromFileBody: UploadRoomsFromFileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadRoomsFromFile200>> => {
    
    
    return axios.default.post(
      `/api/room/upload`,
      uploadRoomsFromFileBody,options
    );
  }



export const getUploadRoomsFromFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRoomsFromFile>>, TError,{data: UploadRoomsFromFileBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadRoomsFromFile>>, TError,{data: UploadRoomsFromFileBody}, TContext> => {

const mutationKey = ['uploadRoomsFromFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadRoomsFromFile>>, {data: UploadRoomsFromFileBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadRoomsFromFile(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadRoomsFromFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadRoomsFromFile>>>
    export type UploadRoomsFromFileMutationBody = UploadRoomsFromFileBody
    export type UploadRoomsFromFileMutationError = AxiosError<unknown>

    /**
 * @summary Upload room data
 */
export const useUploadRoomsFromFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRoomsFromFile>>, TError,{data: UploadRoomsFromFileBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadRoomsFromFile>>,
        TError,
        {data: UploadRoomsFromFileBody},
        TContext
      > => {

      const mutationOptions = getUploadRoomsFromFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateRoom = (
    roomRequest: RoomRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RoomResponse>> => {
    
    
    return axios.default.post(
      `/api/room/update`,
      roomRequest,options
    );
  }



export const getUpdateRoomMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoom>>, TError,{data: RoomRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateRoom>>, TError,{data: RoomRequest}, TContext> => {

const mutationKey = ['updateRoom'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoom>>, {data: RoomRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateRoom(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoomMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoom>>>
    export type UpdateRoomMutationBody = RoomRequest
    export type UpdateRoomMutationError = AxiosError<unknown>

    export const useUpdateRoom = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoom>>, TError,{data: RoomRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRoom>>,
        TError,
        {data: RoomRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRoomMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createRoom = (
    roomRequest: RoomRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateRoom200>> => {
    
    
    return axios.default.post(
      `/api/room/new`,
      roomRequest,options
    );
  }



export const getCreateRoomMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoom>>, TError,{data: RoomRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createRoom>>, TError,{data: RoomRequest}, TContext> => {

const mutationKey = ['createRoom'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRoom>>, {data: RoomRequest}> = (props) => {
          const {data} = props ?? {};

          return  createRoom(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRoomMutationResult = NonNullable<Awaited<ReturnType<typeof createRoom>>>
    export type CreateRoomMutationBody = RoomRequest
    export type CreateRoomMutationError = AxiosError<unknown>

    export const useCreateRoom = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoom>>, TError,{data: RoomRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRoom>>,
        TError,
        {data: RoomRequest},
        TContext
      > => {

      const mutationOptions = getCreateRoomMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateRate = (
    rateRequest: RateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RateResponse>> => {
    
    
    return axios.default.post(
      `/api/rate/update`,
      rateRequest,options
    );
  }



export const getUpdateRateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRate>>, TError,{data: RateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateRate>>, TError,{data: RateRequest}, TContext> => {

const mutationKey = ['updateRate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRate>>, {data: RateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateRate(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRateMutationResult = NonNullable<Awaited<ReturnType<typeof updateRate>>>
    export type UpdateRateMutationBody = RateRequest
    export type UpdateRateMutationError = AxiosError<unknown>

    export const useUpdateRate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRate>>, TError,{data: RateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRate>>,
        TError,
        {data: RateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createRate = (
    rateRequest: RateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateRate200>> => {
    
    
    return axios.default.post(
      `/api/rate/new`,
      rateRequest,options
    );
  }



export const getCreateRateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRate>>, TError,{data: RateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createRate>>, TError,{data: RateRequest}, TContext> => {

const mutationKey = ['createRate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRate>>, {data: RateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createRate(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRateMutationResult = NonNullable<Awaited<ReturnType<typeof createRate>>>
    export type CreateRateMutationBody = RateRequest
    export type CreateRateMutationError = AxiosError<unknown>

    export const useCreateRate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRate>>, TError,{data: RateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRate>>,
        TError,
        {data: RateRequest},
        TContext
      > => {

      const mutationOptions = getCreateRateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records a manual payment or refund against a booking
 * @summary Record a payment
 */
export const recordPayment = (
    paymentRequest: PaymentRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaymentResponse>> => {
    
    
    return axios.default.post(
      `/api/payments`,
      paymentRequest,options
    );
  }



export const getRecordPaymentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{data: PaymentRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{data: PaymentRequest}, TContext> => {

const mutationKey = ['recordPayment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPayment>>, {data: PaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordPayment(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordPayment>>>
    export type RecordPaymentMutationBody = PaymentRequest
    export type RecordPaymentMutationError = AxiosError<unknown>

    /**
 * @summary Record a payment
 */
export const useRecordPayment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{data: PaymentRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordPayment>>,
        TError,
        {data: PaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const initiateRff = (
    invoiceId: number,
    mealRffInitiateRequest: MealRffInitiateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InitiateRff200>> => {
    
    
    return axios.default.post(
      `/api/meals/rff-payments/emergency-invoices/${invoiceId}/initiate`,
      mealRffInitiateRequest,options
    );
  }



export const getInitiateRffMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateRff>>, TError,{invoiceId: number;data: MealRffInitiateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof initiateRff>>, TError,{invoiceId: number;data: MealRffInitiateRequest}, TContext> => {

const mutationKey = ['initiateRff'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateRff>>, {invoiceId: number;data: MealRffInitiateRequest}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  initiateRff(invoiceId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitiateRffMutationResult = NonNullable<Awaited<ReturnType<typeof initiateRff>>>
    export type InitiateRffMutationBody = MealRffInitiateRequest
    export type InitiateRffMutationError = AxiosError<unknown>

    export const useInitiateRff = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateRff>>, TError,{invoiceId: number;data: MealRffInitiateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiateRff>>,
        TError,
        {invoiceId: number;data: MealRffInitiateRequest},
        TContext
      > => {

      const mutationOptions = getInitiateRffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Submits a draft meal request and moves it to the first approval stage.
 * @summary Submit a draft meal request
 */
export const submitRequest = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/${requestId}/submit`,undefined,options
    );
  }



export const getSubmitRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRequest>>, TError,{requestId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitRequest>>, TError,{requestId: number}, TContext> => {

const mutationKey = ['submitRequest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitRequest>>, {requestId: number}> = (props) => {
          const {requestId} = props ?? {};

          return  submitRequest(requestId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitRequestMutationResult = NonNullable<Awaited<ReturnType<typeof submitRequest>>>
    
    export type SubmitRequestMutationError = AxiosError<unknown>

    /**
 * @summary Submit a draft meal request
 */
export const useSubmitRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRequest>>, TError,{requestId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitRequest>>,
        TError,
        {requestId: number},
        TContext
      > => {

      const mutationOptions = getSubmitRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Marks the invoice as SENT_TO_HOD so the HOD can see it. Can only be called once.
 * @summary Send invoice to HOD (Meals Admin)
 */
export const sendInvoiceToHod = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealInvoiceResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/${requestId}/invoice/send`,undefined,options
    );
  }



export const getSendInvoiceToHodMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvoiceToHod>>, TError,{requestId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendInvoiceToHod>>, TError,{requestId: number}, TContext> => {

const mutationKey = ['sendInvoiceToHod'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInvoiceToHod>>, {requestId: number}> = (props) => {
          const {requestId} = props ?? {};

          return  sendInvoiceToHod(requestId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInvoiceToHodMutationResult = NonNullable<Awaited<ReturnType<typeof sendInvoiceToHod>>>
    
    export type SendInvoiceToHodMutationError = AxiosError<unknown>

    /**
 * @summary Send invoice to HOD (Meals Admin)
 */
export const useSendInvoiceToHod = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvoiceToHod>>, TError,{requestId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInvoiceToHod>>,
        TError,
        {requestId: number},
        TContext
      > => {

      const mutationOptions = getSendInvoiceToHodMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates an invoice for the meal request. The request must have been approved by the Meals Admin first. Can only be called once.
 * @summary Generate an invoice (Meals Admin)
 */
export const generateInvoice = (
    requestId: number,
    mealInvoiceRequest: MealInvoiceRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealInvoiceResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/${requestId}/invoice/generate`,
      mealInvoiceRequest,options
    );
  }



export const getGenerateInvoiceMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateInvoice>>, TError,{requestId: number;data: MealInvoiceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof generateInvoice>>, TError,{requestId: number;data: MealInvoiceRequest}, TContext> => {

const mutationKey = ['generateInvoice'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateInvoice>>, {requestId: number;data: MealInvoiceRequest}> = (props) => {
          const {requestId,data} = props ?? {};

          return  generateInvoice(requestId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof generateInvoice>>>
    export type GenerateInvoiceMutationBody = MealInvoiceRequest
    export type GenerateInvoiceMutationError = AxiosError<unknown>

    /**
 * @summary Generate an invoice (Meals Admin)
 */
export const useGenerateInvoice = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateInvoice>>, TError,{requestId: number;data: MealInvoiceRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateInvoice>>,
        TError,
        {requestId: number;data: MealInvoiceRequest},
        TContext
      > => {

      const mutationOptions = getGenerateInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a new draft meal request for the authenticated user.
 * @summary Create a meal request draft
 */
export const createDraft = (
    jsonNode: JsonNode, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/draft`,
      jsonNode,options
    );
  }



export const getCreateDraftMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraft>>, TError,{data: JsonNode}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createDraft>>, TError,{data: JsonNode}, TContext> => {

const mutationKey = ['createDraft'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDraft>>, {data: JsonNode}> = (props) => {
          const {data} = props ?? {};

          return  createDraft(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createDraft>>>
    export type CreateDraftMutationBody = JsonNode
    export type CreateDraftMutationError = AxiosError<unknown>

    /**
 * @summary Create a meal request draft
 */
export const useCreateDraft = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraft>>, TError,{data: JsonNode}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDraft>>,
        TError,
        {data: JsonNode},
        TContext
      > => {

      const mutationOptions = getCreateDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Stores a file and returns its metadata. Include the returned object in the request's attachments list when saving the draft.
 * @summary Upload a meal-request agenda attachment
 */
export const uploadAttachment = (
    uploadAttachmentBody: UploadAttachmentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealAttachmentUploadResponse>> => {
    
    const formData = new FormData();
formData.append(`file`, uploadAttachmentBody.file)

    return axios.default.post(
      `/api/meals/requests/attachments/upload`,
      formData,options
    );
  }



export const getUploadAttachmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{data: UploadAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{data: UploadAttachmentBody}, TContext> => {

const mutationKey = ['uploadAttachment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAttachment>>, {data: UploadAttachmentBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadAttachment(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAttachment>>>
    export type UploadAttachmentMutationBody = UploadAttachmentBody
    export type UploadAttachmentMutationError = AxiosError<unknown>

    /**
 * @summary Upload a meal-request agenda attachment
 */
export const useUploadAttachment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{data: UploadAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadAttachment>>,
        TError,
        {data: UploadAttachmentBody},
        TContext
      > => {

      const mutationOptions = getUploadAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Rejects a pending department meal request at the HOD stage.
 * @summary Reject a meal request as HOD
 */
export const rejectAsHod = (
    requestId: number,
    mealApprovalDecisionRequest: MealApprovalDecisionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/approvals/hod/${requestId}/reject`,
      mealApprovalDecisionRequest,options
    );
  }



export const getRejectAsHodMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAsHod>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAsHod>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext> => {

const mutationKey = ['rejectAsHod'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAsHod>>, {requestId: number;data: MealApprovalDecisionRequest}> = (props) => {
          const {requestId,data} = props ?? {};

          return  rejectAsHod(requestId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectAsHodMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAsHod>>>
    export type RejectAsHodMutationBody = MealApprovalDecisionRequest
    export type RejectAsHodMutationError = AxiosError<unknown>

    /**
 * @summary Reject a meal request as HOD
 */
export const useRejectAsHod = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAsHod>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAsHod>>,
        TError,
        {requestId: number;data: MealApprovalDecisionRequest},
        TContext
      > => {

      const mutationOptions = getRejectAsHodMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Approves a pending department meal request at the HOD stage.
 * @summary Approve a meal request as HOD
 */
export const approveAsHod = (
    requestId: number,
    mealApprovalDecisionRequest: MealApprovalDecisionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/approvals/hod/${requestId}/approve`,
      mealApprovalDecisionRequest,options
    );
  }



export const getApproveAsHodMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAsHod>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approveAsHod>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext> => {

const mutationKey = ['approveAsHod'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAsHod>>, {requestId: number;data: MealApprovalDecisionRequest}> = (props) => {
          const {requestId,data} = props ?? {};

          return  approveAsHod(requestId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveAsHodMutationResult = NonNullable<Awaited<ReturnType<typeof approveAsHod>>>
    export type ApproveAsHodMutationBody = MealApprovalDecisionRequest
    export type ApproveAsHodMutationError = AxiosError<unknown>

    /**
 * @summary Approve a meal request as HOD
 */
export const useApproveAsHod = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAsHod>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAsHod>>,
        TError,
        {requestId: number;data: MealApprovalDecisionRequest},
        TContext
      > => {

      const mutationOptions = getApproveAsHodMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Declines a pending meal request at the Meals Admin stage.
 * @summary Decline a meal request as Meals Admin
 */
export const declineAsMealsAdmin = (
    requestId: number,
    mealApprovalDecisionRequest: MealApprovalDecisionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/admin/${requestId}/decline`,
      mealApprovalDecisionRequest,options
    );
  }



export const getDeclineAsMealsAdminMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineAsMealsAdmin>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof declineAsMealsAdmin>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext> => {

const mutationKey = ['declineAsMealsAdmin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineAsMealsAdmin>>, {requestId: number;data: MealApprovalDecisionRequest}> = (props) => {
          const {requestId,data} = props ?? {};

          return  declineAsMealsAdmin(requestId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineAsMealsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof declineAsMealsAdmin>>>
    export type DeclineAsMealsAdminMutationBody = MealApprovalDecisionRequest
    export type DeclineAsMealsAdminMutationError = AxiosError<unknown>

    /**
 * @summary Decline a meal request as Meals Admin
 */
export const useDeclineAsMealsAdmin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineAsMealsAdmin>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declineAsMealsAdmin>>,
        TError,
        {requestId: number;data: MealApprovalDecisionRequest},
        TContext
      > => {

      const mutationOptions = getDeclineAsMealsAdminMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Approves a pending meal request at the Meals Admin stage and moves it to chef review.
 * @summary Approve a meal request as Meals Admin
 */
export const approveAsMealsAdmin = (
    requestId: number,
    mealApprovalDecisionRequest: MealApprovalDecisionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/admin/${requestId}/approve`,
      mealApprovalDecisionRequest,options
    );
  }



export const getApproveAsMealsAdminMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAsMealsAdmin>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approveAsMealsAdmin>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext> => {

const mutationKey = ['approveAsMealsAdmin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAsMealsAdmin>>, {requestId: number;data: MealApprovalDecisionRequest}> = (props) => {
          const {requestId,data} = props ?? {};

          return  approveAsMealsAdmin(requestId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveAsMealsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof approveAsMealsAdmin>>>
    export type ApproveAsMealsAdminMutationBody = MealApprovalDecisionRequest
    export type ApproveAsMealsAdminMutationError = AxiosError<unknown>

    /**
 * @summary Approve a meal request as Meals Admin
 */
export const useApproveAsMealsAdmin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAsMealsAdmin>>, TError,{requestId: number;data: MealApprovalDecisionRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAsMealsAdmin>>,
        TError,
        {requestId: number;data: MealApprovalDecisionRequest},
        TContext
      > => {

      const mutationOptions = getApproveAsMealsAdminMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates and submits an emergency meal request on behalf of a selected faculty or department.
 * @summary Submit an emergency meal request as Meals Admin
 */
export const submitEmergencyRequestAsMealsAdmin = (
    jsonNode: JsonNode, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.post(
      `/api/meals/requests/admin/emergency`,
      jsonNode,options
    );
  }



export const getSubmitEmergencyRequestAsMealsAdminMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmergencyRequestAsMealsAdmin>>, TError,{data: JsonNode}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitEmergencyRequestAsMealsAdmin>>, TError,{data: JsonNode}, TContext> => {

const mutationKey = ['submitEmergencyRequestAsMealsAdmin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmergencyRequestAsMealsAdmin>>, {data: JsonNode}> = (props) => {
          const {data} = props ?? {};

          return  submitEmergencyRequestAsMealsAdmin(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmergencyRequestAsMealsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmergencyRequestAsMealsAdmin>>>
    export type SubmitEmergencyRequestAsMealsAdminMutationBody = JsonNode
    export type SubmitEmergencyRequestAsMealsAdminMutationError = AxiosError<unknown>

    /**
 * @summary Submit an emergency meal request as Meals Admin
 */
export const useSubmitEmergencyRequestAsMealsAdmin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmergencyRequestAsMealsAdmin>>, TError,{data: JsonNode}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitEmergencyRequestAsMealsAdmin>>,
        TError,
        {data: JsonNode},
        TContext
      > => {

      const mutationOptions = getSubmitEmergencyRequestAsMealsAdminMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the workflow definitions used to route meal requests through approval.
 * @summary List workflow configurations
 */
export const getWorkflows = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkflowConfigurationDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/workflows`,options
    );
  }




export const getGetWorkflowsQueryKey = () => {
    return [
    `/api/meals/config/workflows`
    ] as const;
    }

    
export const getGetWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflows>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflows>>> = ({ signal }) => getWorkflows({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflows>>>
export type GetWorkflowsQueryError = AxiosError<unknown>


export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getWorkflows>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getWorkflows>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List workflow configurations
 */

export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new stored workflow definition for meals approvals.
 * @summary Create a workflow configuration
 */
export const createWorkflow = (
    workflowConfigurationDto: WorkflowConfigurationDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkflowConfigurationDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/workflows`,
      workflowConfigurationDto,options
    );
  }



export const getCreateWorkflowMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,{data: WorkflowConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,{data: WorkflowConfigurationDto}, TContext> => {

const mutationKey = ['createWorkflow'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkflow>>, {data: WorkflowConfigurationDto}> = (props) => {
          const {data} = props ?? {};

          return  createWorkflow(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkflow>>>
    export type CreateWorkflowMutationBody = WorkflowConfigurationDto
    export type CreateWorkflowMutationError = AxiosError<unknown>

    /**
 * @summary Create a workflow configuration
 */
export const useCreateWorkflow = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,{data: WorkflowConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkflow>>,
        TError,
        {data: WorkflowConfigurationDto},
        TContext
      > => {

      const mutationOptions = getCreateWorkflowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns service types such as lunch, tea, or conference catering.
 * @summary List service types
 */
export const getServiceTypes = (
    params?: GetServiceTypesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceTypeDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/service-types`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetServiceTypesQueryKey = (params?: GetServiceTypesParams,) => {
    return [
    `/api/meals/config/service-types`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetServiceTypesQueryOptions = <TData = Awaited<ReturnType<typeof getServiceTypes>>, TError = AxiosError<unknown>>(params?: GetServiceTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceTypes>>> = ({ signal }) => getServiceTypes(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceTypes>>>
export type GetServiceTypesQueryError = AxiosError<unknown>


export function useGetServiceTypes<TData = Awaited<ReturnType<typeof getServiceTypes>>, TError = AxiosError<unknown>>(
 params: undefined |  GetServiceTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceTypes>>,
          TError,
          Awaited<ReturnType<typeof getServiceTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceTypes<TData = Awaited<ReturnType<typeof getServiceTypes>>, TError = AxiosError<unknown>>(
 params?: GetServiceTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceTypes>>,
          TError,
          Awaited<ReturnType<typeof getServiceTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceTypes<TData = Awaited<ReturnType<typeof getServiceTypes>>, TError = AxiosError<unknown>>(
 params?: GetServiceTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service types
 */

export function useGetServiceTypes<TData = Awaited<ReturnType<typeof getServiceTypes>>, TError = AxiosError<unknown>>(
 params?: GetServiceTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new service type for meals configuration.
 * @summary Create a service type
 */
export const createServiceType = (
    serviceTypeDto: ServiceTypeDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceTypeDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/service-types`,
      serviceTypeDto,options
    );
  }



export const getCreateServiceTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceType>>, TError,{data: ServiceTypeDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createServiceType>>, TError,{data: ServiceTypeDto}, TContext> => {

const mutationKey = ['createServiceType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createServiceType>>, {data: ServiceTypeDto}> = (props) => {
          const {data} = props ?? {};

          return  createServiceType(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createServiceType>>>
    export type CreateServiceTypeMutationBody = ServiceTypeDto
    export type CreateServiceTypeMutationError = AxiosError<unknown>

    /**
 * @summary Create a service type
 */
export const useCreateServiceType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceType>>, TError,{data: ServiceTypeDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createServiceType>>,
        TError,
        {data: ServiceTypeDto},
        TContext
      > => {

      const mutationOptions = getCreateServiceTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns configured price lines and their guest-category rates for each meal plan.
 * @summary List meal price configurations
 */
export const getPriceConfigurations = (
    params?: GetPriceConfigurationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceConfigurationDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/price-configurations`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetPriceConfigurationsQueryKey = (params?: GetPriceConfigurationsParams,) => {
    return [
    `/api/meals/config/price-configurations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPriceConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof getPriceConfigurations>>, TError = AxiosError<unknown>>(params?: GetPriceConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurations>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriceConfigurationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPriceConfigurations>>> = ({ signal }) => getPriceConfigurations(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriceConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof getPriceConfigurations>>>
export type GetPriceConfigurationsQueryError = AxiosError<unknown>


export function useGetPriceConfigurations<TData = Awaited<ReturnType<typeof getPriceConfigurations>>, TError = AxiosError<unknown>>(
 params: undefined |  GetPriceConfigurationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getPriceConfigurations>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceConfigurations<TData = Awaited<ReturnType<typeof getPriceConfigurations>>, TError = AxiosError<unknown>>(
 params?: GetPriceConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getPriceConfigurations>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceConfigurations<TData = Awaited<ReturnType<typeof getPriceConfigurations>>, TError = AxiosError<unknown>>(
 params?: GetPriceConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurations>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal price configurations
 */

export function useGetPriceConfigurations<TData = Awaited<ReturnType<typeof getPriceConfigurations>>, TError = AxiosError<unknown>>(
 params?: GetPriceConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceConfigurations>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriceConfigurationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a price configuration and its guest-category rates for a meal plan.
 * @summary Create a meal price configuration
 */
export const createPriceConfiguration = (
    priceConfigurationDto: PriceConfigurationDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceConfigurationDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/price-configurations`,
      priceConfigurationDto,options
    );
  }



export const getCreatePriceConfigurationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceConfiguration>>, TError,{data: PriceConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPriceConfiguration>>, TError,{data: PriceConfigurationDto}, TContext> => {

const mutationKey = ['createPriceConfiguration'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceConfiguration>>, {data: PriceConfigurationDto}> = (props) => {
          const {data} = props ?? {};

          return  createPriceConfiguration(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceConfiguration>>>
    export type CreatePriceConfigurationMutationBody = PriceConfigurationDto
    export type CreatePriceConfigurationMutationError = AxiosError<unknown>

    /**
 * @summary Create a meal price configuration
 */
export const useCreatePriceConfiguration = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceConfiguration>>, TError,{data: PriceConfigurationDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPriceConfiguration>>,
        TError,
        {data: PriceConfigurationDto},
        TContext
      > => {

      const mutationOptions = getCreatePriceConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns meal plans that can be selected on meal requests.
 * @summary List meal plans
 */
export const getMealPlans = (
    params?: GetMealPlansParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealPlanDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/meal-plans`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetMealPlansQueryKey = (params?: GetMealPlansParams,) => {
    return [
    `/api/meals/config/meal-plans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMealPlansQueryOptions = <TData = Awaited<ReturnType<typeof getMealPlans>>, TError = AxiosError<unknown>>(params?: GetMealPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlans>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMealPlansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMealPlans>>> = ({ signal }) => getMealPlans(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMealPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMealPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getMealPlans>>>
export type GetMealPlansQueryError = AxiosError<unknown>


export function useGetMealPlans<TData = Awaited<ReturnType<typeof getMealPlans>>, TError = AxiosError<unknown>>(
 params: undefined |  GetMealPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMealPlans>>,
          TError,
          Awaited<ReturnType<typeof getMealPlans>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMealPlans<TData = Awaited<ReturnType<typeof getMealPlans>>, TError = AxiosError<unknown>>(
 params?: GetMealPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMealPlans>>,
          TError,
          Awaited<ReturnType<typeof getMealPlans>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMealPlans<TData = Awaited<ReturnType<typeof getMealPlans>>, TError = AxiosError<unknown>>(
 params?: GetMealPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlans>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal plans
 */

export function useGetMealPlans<TData = Awaited<ReturnType<typeof getMealPlans>>, TError = AxiosError<unknown>>(
 params?: GetMealPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMealPlans>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMealPlansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new meal plan for meals configuration.
 * @summary Create a meal plan
 */
export const createMealPlan = (
    mealPlanDto: MealPlanDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealPlanDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/meal-plans`,
      mealPlanDto,options
    );
  }



export const getCreateMealPlanMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMealPlan>>, TError,{data: MealPlanDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createMealPlan>>, TError,{data: MealPlanDto}, TContext> => {

const mutationKey = ['createMealPlan'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMealPlan>>, {data: MealPlanDto}> = (props) => {
          const {data} = props ?? {};

          return  createMealPlan(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMealPlanMutationResult = NonNullable<Awaited<ReturnType<typeof createMealPlan>>>
    export type CreateMealPlanMutationBody = MealPlanDto
    export type CreateMealPlanMutationError = AxiosError<unknown>

    /**
 * @summary Create a meal plan
 */
export const useCreateMealPlan = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMealPlan>>, TError,{data: MealPlanDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMealPlan>>,
        TError,
        {data: MealPlanDto},
        TContext
      > => {

      const mutationOptions = getCreateMealPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the guest categories used to price meal configurations and request items.
 * @summary List guest categories
 */
export const getGuestCategories = (
    params?: GetGuestCategoriesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestCategoryDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/guest-categories`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetGuestCategoriesQueryKey = (params?: GetGuestCategoriesParams,) => {
    return [
    `/api/meals/config/guest-categories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetGuestCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getGuestCategories>>, TError = AxiosError<unknown>>(params?: GetGuestCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestCategories>>> = ({ signal }) => getGuestCategories(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestCategories>>>
export type GetGuestCategoriesQueryError = AxiosError<unknown>


export function useGetGuestCategories<TData = Awaited<ReturnType<typeof getGuestCategories>>, TError = AxiosError<unknown>>(
 params: undefined |  GetGuestCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestCategories>>,
          TError,
          Awaited<ReturnType<typeof getGuestCategories>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestCategories<TData = Awaited<ReturnType<typeof getGuestCategories>>, TError = AxiosError<unknown>>(
 params?: GetGuestCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestCategories>>,
          TError,
          Awaited<ReturnType<typeof getGuestCategories>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestCategories<TData = Awaited<ReturnType<typeof getGuestCategories>>, TError = AxiosError<unknown>>(
 params?: GetGuestCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List guest categories
 */

export function useGetGuestCategories<TData = Awaited<ReturnType<typeof getGuestCategories>>, TError = AxiosError<unknown>>(
 params?: GetGuestCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new guest category for normalized meal pricing.
 * @summary Create a guest category
 */
export const createGuestCategory = (
    guestCategoryDto: GuestCategoryDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestCategoryDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/guest-categories`,
      guestCategoryDto,options
    );
  }



export const getCreateGuestCategoryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestCategory>>, TError,{data: GuestCategoryDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createGuestCategory>>, TError,{data: GuestCategoryDto}, TContext> => {

const mutationKey = ['createGuestCategory'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuestCategory>>, {data: GuestCategoryDto}> = (props) => {
          const {data} = props ?? {};

          return  createGuestCategory(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGuestCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createGuestCategory>>>
    export type CreateGuestCategoryMutationBody = GuestCategoryDto
    export type CreateGuestCategoryMutationError = AxiosError<unknown>

    /**
 * @summary Create a guest category
 */
export const useCreateGuestCategory = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestCategory>>, TError,{data: GuestCategoryDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGuestCategory>>,
        TError,
        {data: GuestCategoryDto},
        TContext
      > => {

      const mutationOptions = getCreateGuestCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns reusable food items that can be attached to meal plans.
 * @summary List meal food items
 */
export const getFoodItems = (
    params?: GetFoodItemsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealFoodItemDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/food-items`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetFoodItemsQueryKey = (params?: GetFoodItemsParams,) => {
    return [
    `/api/meals/config/food-items`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFoodItemsQueryOptions = <TData = Awaited<ReturnType<typeof getFoodItems>>, TError = AxiosError<unknown>>(params?: GetFoodItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItems>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFoodItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFoodItems>>> = ({ signal }) => getFoodItems(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFoodItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFoodItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getFoodItems>>>
export type GetFoodItemsQueryError = AxiosError<unknown>


export function useGetFoodItems<TData = Awaited<ReturnType<typeof getFoodItems>>, TError = AxiosError<unknown>>(
 params: undefined |  GetFoodItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFoodItems>>,
          TError,
          Awaited<ReturnType<typeof getFoodItems>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFoodItems<TData = Awaited<ReturnType<typeof getFoodItems>>, TError = AxiosError<unknown>>(
 params?: GetFoodItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFoodItems>>,
          TError,
          Awaited<ReturnType<typeof getFoodItems>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFoodItems<TData = Awaited<ReturnType<typeof getFoodItems>>, TError = AxiosError<unknown>>(
 params?: GetFoodItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItems>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal food items
 */

export function useGetFoodItems<TData = Awaited<ReturnType<typeof getFoodItems>>, TError = AxiosError<unknown>>(
 params?: GetFoodItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoodItems>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFoodItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a reusable food item that can be selected on meal plans.
 * @summary Create a meal food item
 */
export const createFoodItem = (
    mealFoodItemDto: MealFoodItemDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealFoodItemDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/food-items`,
      mealFoodItemDto,options
    );
  }



export const getCreateFoodItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFoodItem>>, TError,{data: MealFoodItemDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createFoodItem>>, TError,{data: MealFoodItemDto}, TContext> => {

const mutationKey = ['createFoodItem'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFoodItem>>, {data: MealFoodItemDto}> = (props) => {
          const {data} = props ?? {};

          return  createFoodItem(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFoodItemMutationResult = NonNullable<Awaited<ReturnType<typeof createFoodItem>>>
    export type CreateFoodItemMutationBody = MealFoodItemDto
    export type CreateFoodItemMutationError = AxiosError<unknown>

    /**
 * @summary Create a meal food item
 */
export const useCreateFoodItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFoodItem>>, TError,{data: MealFoodItemDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFoodItem>>,
        TError,
        {data: MealFoodItemDto},
        TContext
      > => {

      const mutationOptions = getCreateFoodItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns departments that can submit or manage meal requests.
 * @summary List meal departments
 */
export const getDepartments = (
    params?: GetDepartmentsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DepartmentDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/departments`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDepartmentsQueryKey = (params?: GetDepartmentsParams,) => {
    return [
    `/api/meals/config/departments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof getDepartments>>, TError = AxiosError<unknown>>(params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartments>>> = ({ signal }) => getDepartments(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartments>>>
export type GetDepartmentsQueryError = AxiosError<unknown>


export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = AxiosError<unknown>>(
 params: undefined |  GetDepartmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartments>>,
          TError,
          Awaited<ReturnType<typeof getDepartments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = AxiosError<unknown>>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartments>>,
          TError,
          Awaited<ReturnType<typeof getDepartments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = AxiosError<unknown>>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal departments
 */

export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = AxiosError<unknown>>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new department record for the meals module.
 * @summary Create a meal department
 */
export const createDepartment = (
    departmentDto: DepartmentDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DepartmentDto>> => {
    
    
    return axios.default.post(
      `/api/meals/config/departments`,
      departmentDto,options
    );
  }



export const getCreateDepartmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: DepartmentDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: DepartmentDto}, TContext> => {

const mutationKey = ['createDepartment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartment>>, {data: DepartmentDto}> = (props) => {
          const {data} = props ?? {};

          return  createDepartment(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartment>>>
    export type CreateDepartmentMutationBody = DepartmentDto
    export type CreateDepartmentMutationError = AxiosError<unknown>

    /**
 * @summary Create a meal department
 */
export const useCreateDepartment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: DepartmentDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDepartment>>,
        TError,
        {data: DepartmentDto},
        TContext
      > => {

      const mutationOptions = getCreateDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateGuestHouse = (
    guestHouseRequest: GuestHouseRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestHouseResponse>> => {
    
    
    return axios.default.post(
      `/api/guesthouse/update`,
      guestHouseRequest,options
    );
  }



export const getUpdateGuestHouseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestHouse>>, TError,{data: GuestHouseRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateGuestHouse>>, TError,{data: GuestHouseRequest}, TContext> => {

const mutationKey = ['updateGuestHouse'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGuestHouse>>, {data: GuestHouseRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateGuestHouse(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGuestHouseMutationResult = NonNullable<Awaited<ReturnType<typeof updateGuestHouse>>>
    export type UpdateGuestHouseMutationBody = GuestHouseRequest
    export type UpdateGuestHouseMutationError = AxiosError<unknown>

    export const useUpdateGuestHouse = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestHouse>>, TError,{data: GuestHouseRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGuestHouse>>,
        TError,
        {data: GuestHouseRequest},
        TContext
      > => {

      const mutationOptions = getUpdateGuestHouseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createGuestHouse = (
    guestHouseRequest: GuestHouseRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateGuestHouse200>> => {
    
    
    return axios.default.post(
      `/api/guesthouse/new`,
      guestHouseRequest,options
    );
  }



export const getCreateGuestHouseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestHouse>>, TError,{data: GuestHouseRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createGuestHouse>>, TError,{data: GuestHouseRequest}, TContext> => {

const mutationKey = ['createGuestHouse'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuestHouse>>, {data: GuestHouseRequest}> = (props) => {
          const {data} = props ?? {};

          return  createGuestHouse(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGuestHouseMutationResult = NonNullable<Awaited<ReturnType<typeof createGuestHouse>>>
    export type CreateGuestHouseMutationBody = GuestHouseRequest
    export type CreateGuestHouseMutationError = AxiosError<unknown>

    export const useCreateGuestHouse = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestHouse>>, TError,{data: GuestHouseRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGuestHouse>>,
        TError,
        {data: GuestHouseRequest},
        TContext
      > => {

      const mutationOptions = getCreateGuestHouseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const uploadGuestHouseImage = (
    uploadGuestHouseImageBody: UploadGuestHouseImageBody,
    params: UploadGuestHouseImageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadGuestHouseImage200>> => {
    
    const formData = new FormData();
formData.append(`file`, uploadGuestHouseImageBody.file)

    return axios.default.post(
      `/api/guesthouse/images/upload`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUploadGuestHouseImageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadGuestHouseImage>>, TError,{data: UploadGuestHouseImageBody;params: UploadGuestHouseImageParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadGuestHouseImage>>, TError,{data: UploadGuestHouseImageBody;params: UploadGuestHouseImageParams}, TContext> => {

const mutationKey = ['uploadGuestHouseImage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadGuestHouseImage>>, {data: UploadGuestHouseImageBody;params: UploadGuestHouseImageParams}> = (props) => {
          const {data,params} = props ?? {};

          return  uploadGuestHouseImage(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadGuestHouseImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadGuestHouseImage>>>
    export type UploadGuestHouseImageMutationBody = UploadGuestHouseImageBody
    export type UploadGuestHouseImageMutationError = AxiosError<unknown>

    export const useUploadGuestHouseImage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadGuestHouseImage>>, TError,{data: UploadGuestHouseImageBody;params: UploadGuestHouseImageParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadGuestHouseImage>>,
        TError,
        {data: UploadGuestHouseImageBody;params: UploadGuestHouseImageParams},
        TContext
      > => {

      const mutationOptions = getUploadGuestHouseImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateGuestHouseImage = (
    imageId: number,
    updateGuestHouseImageBody: UpdateGuestHouseImageBody,
    params: UpdateGuestHouseImageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateGuestHouseImage200>> => {
    
    const formData = new FormData();
if(updateGuestHouseImageBody.file !== undefined) {
 formData.append(`file`, updateGuestHouseImageBody.file)
 }

    return axios.default.post(
      `/api/guesthouse/images/update/${imageId}`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUpdateGuestHouseImageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestHouseImage>>, TError,{imageId: number;data: UpdateGuestHouseImageBody;params: UpdateGuestHouseImageParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateGuestHouseImage>>, TError,{imageId: number;data: UpdateGuestHouseImageBody;params: UpdateGuestHouseImageParams}, TContext> => {

const mutationKey = ['updateGuestHouseImage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGuestHouseImage>>, {imageId: number;data: UpdateGuestHouseImageBody;params: UpdateGuestHouseImageParams}> = (props) => {
          const {imageId,data,params} = props ?? {};

          return  updateGuestHouseImage(imageId,data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGuestHouseImageMutationResult = NonNullable<Awaited<ReturnType<typeof updateGuestHouseImage>>>
    export type UpdateGuestHouseImageMutationBody = UpdateGuestHouseImageBody
    export type UpdateGuestHouseImageMutationError = AxiosError<unknown>

    export const useUpdateGuestHouseImage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestHouseImage>>, TError,{imageId: number;data: UpdateGuestHouseImageBody;params: UpdateGuestHouseImageParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGuestHouseImage>>,
        TError,
        {imageId: number;data: UpdateGuestHouseImageBody;params: UpdateGuestHouseImageParams},
        TContext
      > => {

      const mutationOptions = getUpdateGuestHouseImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAllGuests = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Guest[]>> => {
    
    
    return axios.default.get(
      `/api/guest`,options
    );
  }




export const getGetAllGuestsQueryKey = () => {
    return [
    `/api/guest`
    ] as const;
    }

    
export const getGetAllGuestsQueryOptions = <TData = Awaited<ReturnType<typeof getAllGuests>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuests>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllGuestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllGuests>>> = ({ signal }) => getAllGuests({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllGuests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllGuestsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllGuests>>>
export type GetAllGuestsQueryError = AxiosError<unknown>


export function useGetAllGuests<TData = Awaited<ReturnType<typeof getAllGuests>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGuests>>,
          TError,
          Awaited<ReturnType<typeof getAllGuests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllGuests<TData = Awaited<ReturnType<typeof getAllGuests>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGuests>>,
          TError,
          Awaited<ReturnType<typeof getAllGuests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllGuests<TData = Awaited<ReturnType<typeof getAllGuests>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllGuests<TData = Awaited<ReturnType<typeof getAllGuests>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllGuestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createGuest = (
    guestRequest: GuestRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Guest>> => {
    
    
    return axios.default.post(
      `/api/guest`,
      guestRequest,options
    );
  }



export const getCreateGuestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuest>>, TError,{data: GuestRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createGuest>>, TError,{data: GuestRequest}, TContext> => {

const mutationKey = ['createGuest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuest>>, {data: GuestRequest}> = (props) => {
          const {data} = props ?? {};

          return  createGuest(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGuestMutationResult = NonNullable<Awaited<ReturnType<typeof createGuest>>>
    export type CreateGuestMutationBody = GuestRequest
    export type CreateGuestMutationError = AxiosError<unknown>

    export const useCreateGuest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuest>>, TError,{data: GuestRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGuest>>,
        TError,
        {data: GuestRequest},
        TContext
      > => {

      const mutationOptions = getCreateGuestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Bulk upload guest information from CSV or Excel file
 * @summary Upload guest data
 */
export const uploadGuestsFromFile = (
    uploadGuestsFromFileBody: UploadGuestsFromFileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadGuestsFromFile200>> => {
    
    
    return axios.default.post(
      `/api/guest/upload`,
      uploadGuestsFromFileBody,options
    );
  }



export const getUploadGuestsFromFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadGuestsFromFile>>, TError,{data: UploadGuestsFromFileBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadGuestsFromFile>>, TError,{data: UploadGuestsFromFileBody}, TContext> => {

const mutationKey = ['uploadGuestsFromFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadGuestsFromFile>>, {data: UploadGuestsFromFileBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadGuestsFromFile(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadGuestsFromFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadGuestsFromFile>>>
    export type UploadGuestsFromFileMutationBody = UploadGuestsFromFileBody
    export type UploadGuestsFromFileMutationError = AxiosError<unknown>

    /**
 * @summary Upload guest data
 */
export const useUploadGuestsFromFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadGuestsFromFile>>, TError,{data: UploadGuestsFromFileBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadGuestsFromFile>>,
        TError,
        {data: UploadGuestsFromFileBody},
        TContext
      > => {

      const mutationOptions = getUploadGuestsFromFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAllGuestInfo = (
    params?: GetAllGuestInfoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseGuestInfo>> => {
    
    
    return axios.default.get(
      `/api/guest-info`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllGuestInfoQueryKey = (params?: GetAllGuestInfoParams,) => {
    return [
    `/api/guest-info`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllGuestInfoQueryOptions = <TData = Awaited<ReturnType<typeof getAllGuestInfo>>, TError = AxiosError<unknown>>(params?: GetAllGuestInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllGuestInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllGuestInfo>>> = ({ signal }) => getAllGuestInfo(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllGuestInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllGuestInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getAllGuestInfo>>>
export type GetAllGuestInfoQueryError = AxiosError<unknown>


export function useGetAllGuestInfo<TData = Awaited<ReturnType<typeof getAllGuestInfo>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllGuestInfoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGuestInfo>>,
          TError,
          Awaited<ReturnType<typeof getAllGuestInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllGuestInfo<TData = Awaited<ReturnType<typeof getAllGuestInfo>>, TError = AxiosError<unknown>>(
 params?: GetAllGuestInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGuestInfo>>,
          TError,
          Awaited<ReturnType<typeof getAllGuestInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllGuestInfo<TData = Awaited<ReturnType<typeof getAllGuestInfo>>, TError = AxiosError<unknown>>(
 params?: GetAllGuestInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllGuestInfo<TData = Awaited<ReturnType<typeof getAllGuestInfo>>, TError = AxiosError<unknown>>(
 params?: GetAllGuestInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllGuestInfoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createGuestInfo = (
    guestInfoRequest: GuestInfoRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateGuestInfo200>> => {
    
    
    return axios.default.post(
      `/api/guest-info`,
      guestInfoRequest,options
    );
  }



export const getCreateGuestInfoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestInfo>>, TError,{data: GuestInfoRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createGuestInfo>>, TError,{data: GuestInfoRequest}, TContext> => {

const mutationKey = ['createGuestInfo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuestInfo>>, {data: GuestInfoRequest}> = (props) => {
          const {data} = props ?? {};

          return  createGuestInfo(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGuestInfoMutationResult = NonNullable<Awaited<ReturnType<typeof createGuestInfo>>>
    export type CreateGuestInfoMutationBody = GuestInfoRequest
    export type CreateGuestInfoMutationError = AxiosError<unknown>

    export const useCreateGuestInfo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestInfo>>, TError,{data: GuestInfoRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGuestInfo>>,
        TError,
        {data: GuestInfoRequest},
        TContext
      > => {

      const mutationOptions = getCreateGuestInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateGuestInfo = (
    guestInfoRequest: GuestInfoRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestInfo>> => {
    
    
    return axios.default.post(
      `/api/guest-info/update`,
      guestInfoRequest,options
    );
  }



export const getUpdateGuestInfoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestInfo>>, TError,{data: GuestInfoRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateGuestInfo>>, TError,{data: GuestInfoRequest}, TContext> => {

const mutationKey = ['updateGuestInfo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGuestInfo>>, {data: GuestInfoRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateGuestInfo(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGuestInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateGuestInfo>>>
    export type UpdateGuestInfoMutationBody = GuestInfoRequest
    export type UpdateGuestInfoMutationError = AxiosError<unknown>

    export const useUpdateGuestInfo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestInfo>>, TError,{data: GuestInfoRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGuestInfo>>,
        TError,
        {data: GuestInfoRequest},
        TContext
      > => {

      const mutationOptions = getUpdateGuestInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const addGuestsToBooking = (
    bookingId: number,
    guestInformationDTO: GuestInformationDTO[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AddGuestsToBooking200>> => {
    
    
    return axios.default.post(
      `/api/bookings/${bookingId}/add-guests`,
      guestInformationDTO,options
    );
  }



export const getAddGuestsToBookingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addGuestsToBooking>>, TError,{bookingId: number;data: GuestInformationDTO[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addGuestsToBooking>>, TError,{bookingId: number;data: GuestInformationDTO[]}, TContext> => {

const mutationKey = ['addGuestsToBooking'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addGuestsToBooking>>, {bookingId: number;data: GuestInformationDTO[]}> = (props) => {
          const {bookingId,data} = props ?? {};

          return  addGuestsToBooking(bookingId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddGuestsToBookingMutationResult = NonNullable<Awaited<ReturnType<typeof addGuestsToBooking>>>
    export type AddGuestsToBookingMutationBody = GuestInformationDTO[]
    export type AddGuestsToBookingMutationError = AxiosError<unknown>

    export const useAddGuestsToBooking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addGuestsToBooking>>, TError,{bookingId: number;data: GuestInformationDTO[]}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addGuestsToBooking>>,
        TError,
        {bookingId: number;data: GuestInformationDTO[]},
        TContext
      > => {

      const mutationOptions = getAddGuestsToBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Bulk upload booking/reservation information from CSV or Excel file
 * @summary Upload booking data
 */
export const uploadBookingsFromFile = (
    uploadBookingsFromFileBody: UploadBookingsFromFileBody,
    params?: UploadBookingsFromFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadBookingsFromFile200>> => {
    
    
    return axios.default.post(
      `/api/bookings/upload`,
      uploadBookingsFromFileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUploadBookingsFromFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadBookingsFromFile>>, TError,{data: UploadBookingsFromFileBody;params?: UploadBookingsFromFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadBookingsFromFile>>, TError,{data: UploadBookingsFromFileBody;params?: UploadBookingsFromFileParams}, TContext> => {

const mutationKey = ['uploadBookingsFromFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadBookingsFromFile>>, {data: UploadBookingsFromFileBody;params?: UploadBookingsFromFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  uploadBookingsFromFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadBookingsFromFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadBookingsFromFile>>>
    export type UploadBookingsFromFileMutationBody = UploadBookingsFromFileBody
    export type UploadBookingsFromFileMutationError = AxiosError<unknown>

    /**
 * @summary Upload booking data
 */
export const useUploadBookingsFromFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadBookingsFromFile>>, TError,{data: UploadBookingsFromFileBody;params?: UploadBookingsFromFileParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadBookingsFromFile>>,
        TError,
        {data: UploadBookingsFromFileBody;params?: UploadBookingsFromFileParams},
        TContext
      > => {

      const mutationOptions = getUploadBookingsFromFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateBooking = (
    bookingRequest: BookingRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateBooking200>> => {
    
    
    return axios.default.post(
      `/api/bookings/update`,
      bookingRequest,options
    );
  }



export const getUpdateBookingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBooking>>, TError,{data: BookingRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateBooking>>, TError,{data: BookingRequest}, TContext> => {

const mutationKey = ['updateBooking'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBooking>>, {data: BookingRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateBooking(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof updateBooking>>>
    export type UpdateBookingMutationBody = BookingRequest
    export type UpdateBookingMutationError = AxiosError<unknown>

    export const useUpdateBooking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBooking>>, TError,{data: BookingRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBooking>>,
        TError,
        {data: BookingRequest},
        TContext
      > => {

      const mutationOptions = getUpdateBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createBooking = (
    bookingRequest: BookingRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateBooking200>> => {
    
    
    return axios.default.post(
      `/api/bookings/new`,
      bookingRequest,options
    );
  }



export const getCreateBookingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BookingRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BookingRequest}, TContext> => {

const mutationKey = ['createBooking'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBooking>>, {data: BookingRequest}> = (props) => {
          const {data} = props ?? {};

          return  createBooking(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createBooking>>>
    export type CreateBookingMutationBody = BookingRequest
    export type CreateBookingMutationError = AxiosError<unknown>

    export const useCreateBooking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BookingRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBooking>>,
        TError,
        {data: BookingRequest},
        TContext
      > => {

      const mutationOptions = getCreateBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createGroupBooking = (
    bookingRequest: BookingRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateGroupBooking200>> => {
    
    
    return axios.default.post(
      `/api/bookings/group`,
      bookingRequest,options
    );
  }



export const getCreateGroupBookingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupBooking>>, TError,{data: BookingRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createGroupBooking>>, TError,{data: BookingRequest}, TContext> => {

const mutationKey = ['createGroupBooking'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroupBooking>>, {data: BookingRequest}> = (props) => {
          const {data} = props ?? {};

          return  createGroupBooking(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createGroupBooking>>>
    export type CreateGroupBookingMutationBody = BookingRequest
    export type CreateGroupBookingMutationError = AxiosError<unknown>

    export const useCreateGroupBooking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupBooking>>, TError,{data: BookingRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroupBooking>>,
        TError,
        {data: BookingRequest},
        TContext
      > => {

      const mutationOptions = getCreateGroupBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const testFreeIPA = (
    loginRequest: LoginRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TestFreeIPA200>> => {
    
    
    return axios.default.post(
      `/api/auth/test-freeipa`,
      loginRequest,options
    );
  }



export const getTestFreeIPAMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testFreeIPA>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof testFreeIPA>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['testFreeIPA'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testFreeIPA>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  testFreeIPA(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestFreeIPAMutationResult = NonNullable<Awaited<ReturnType<typeof testFreeIPA>>>
    export type TestFreeIPAMutationBody = LoginRequest
    export type TestFreeIPAMutationError = AxiosError<unknown>

    export const useTestFreeIPA = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testFreeIPA>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testFreeIPA>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getTestFreeIPAMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const signup = (
    signUpRequest: SignUpRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Signup200>> => {
    
    
    return axios.default.post(
      `/api/auth/signup`,
      signUpRequest,options
    );
  }



export const getSignupMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignUpRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignUpRequest}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {data: SignUpRequest}> = (props) => {
          const {data} = props ?? {};

          return  signup(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = SignUpRequest
    export type SignupMutationError = AxiosError<unknown>

    export const useSignup = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignUpRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {data: SignUpRequest},
        TContext
      > => {

      const mutationOptions = getSignupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const signupFreeIPAUser = (
    freeIPAUserCreateRequest: FreeIPAUserCreateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SignupFreeIPAUser200>> => {
    
    
    return axios.default.post(
      `/api/auth/signup/freeipa`,
      freeIPAUserCreateRequest,options
    );
  }



export const getSignupFreeIPAUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFreeIPAUser>>, TError,{data: FreeIPAUserCreateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signupFreeIPAUser>>, TError,{data: FreeIPAUserCreateRequest}, TContext> => {

const mutationKey = ['signupFreeIPAUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signupFreeIPAUser>>, {data: FreeIPAUserCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  signupFreeIPAUser(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignupFreeIPAUserMutationResult = NonNullable<Awaited<ReturnType<typeof signupFreeIPAUser>>>
    export type SignupFreeIPAUserMutationBody = FreeIPAUserCreateRequest
    export type SignupFreeIPAUserMutationError = AxiosError<unknown>

    export const useSignupFreeIPAUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFreeIPAUser>>, TError,{data: FreeIPAUserCreateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signupFreeIPAUser>>,
        TError,
        {data: FreeIPAUserCreateRequest},
        TContext
      > => {

      const mutationOptions = getSignupFreeIPAUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const login = (
    loginRequest: LoginRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JwtAuthenticationResponse>> => {
    
    
    return axios.default.post(
      `/api/auth/signin`,
      loginRequest,options
    );
  }



export const getLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = AxiosError<unknown>

    export const useLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resetPassword = (
    resetPasswordRequest: ResetPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ResetPassword200>> => {
    
    
    return axios.default.post(
      `/api/auth/reset-password`,
      resetPasswordRequest,options
    );
  }



export const getResetPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequest
    export type ResetPasswordMutationError = AxiosError<unknown>

    export const useResetPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordRequest},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const forgotPassword = (
    forgotPasswordRequest: ForgotPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ForgotPassword200>> => {
    
    
    return axios.default.post(
      `/api/auth/forgot-password`,
      forgotPasswordRequest,options
    );
  }



export const getForgotPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext> => {

const mutationKey = ['forgotPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordRequest
    export type ForgotPasswordMutationError = AxiosError<unknown>

    export const useForgotPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {data: ForgotPasswordRequest},
        TContext
      > => {

      const mutationOptions = getForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAmenity = (
    amenityRequest: AmenityRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Amenity>> => {
    
    
    return axios.default.post(
      `/api/amenity/update`,
      amenityRequest,options
    );
  }



export const getUpdateAmenityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAmenity>>, TError,{data: AmenityRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateAmenity>>, TError,{data: AmenityRequest}, TContext> => {

const mutationKey = ['updateAmenity'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAmenity>>, {data: AmenityRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateAmenity(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAmenityMutationResult = NonNullable<Awaited<ReturnType<typeof updateAmenity>>>
    export type UpdateAmenityMutationBody = AmenityRequest
    export type UpdateAmenityMutationError = AxiosError<unknown>

    export const useUpdateAmenity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAmenity>>, TError,{data: AmenityRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAmenity>>,
        TError,
        {data: AmenityRequest},
        TContext
      > => {

      const mutationOptions = getUpdateAmenityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createAmenity = (
    amenityRequest: AmenityRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateAmenity200>> => {
    
    
    return axios.default.post(
      `/api/amenity/new`,
      amenityRequest,options
    );
  }



export const getCreateAmenityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAmenity>>, TError,{data: AmenityRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createAmenity>>, TError,{data: AmenityRequest}, TContext> => {

const mutationKey = ['createAmenity'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAmenity>>, {data: AmenityRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAmenity(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAmenityMutationResult = NonNullable<Awaited<ReturnType<typeof createAmenity>>>
    export type CreateAmenityMutationBody = AmenityRequest
    export type CreateAmenityMutationError = AxiosError<unknown>

    export const useCreateAmenity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAmenity>>, TError,{data: AmenityRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAmenity>>,
        TError,
        {data: AmenityRequest},
        TContext
      > => {

      const mutationOptions = getCreateAmenityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCurrentUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSummary>> => {
    
    
    return axios.default.get(
      `/api/users/user/me`,options
    );
  }




export const getGetCurrentUserQueryKey = () => {
    return [
    `/api/users/user/me`
    ] as const;
    }

    
export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = AxiosError<unknown>


export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const searchUsersByName = (
    params: SearchUsersByNameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchUsersByName200>> => {
    
    
    return axios.default.get(
      `/api/users/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getSearchUsersByNameQueryKey = (params?: SearchUsersByNameParams,) => {
    return [
    `/api/users/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchUsersByNameQueryOptions = <TData = Awaited<ReturnType<typeof searchUsersByName>>, TError = AxiosError<unknown>>(params: SearchUsersByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUsersByNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsersByName>>> = ({ signal }) => searchUsersByName(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchUsersByNameQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsersByName>>>
export type SearchUsersByNameQueryError = AxiosError<unknown>


export function useSearchUsersByName<TData = Awaited<ReturnType<typeof searchUsersByName>>, TError = AxiosError<unknown>>(
 params: SearchUsersByNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsersByName>>,
          TError,
          Awaited<ReturnType<typeof searchUsersByName>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsersByName<TData = Awaited<ReturnType<typeof searchUsersByName>>, TError = AxiosError<unknown>>(
 params: SearchUsersByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsersByName>>,
          TError,
          Awaited<ReturnType<typeof searchUsersByName>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsersByName<TData = Awaited<ReturnType<typeof searchUsersByName>>, TError = AxiosError<unknown>>(
 params: SearchUsersByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchUsersByName<TData = Awaited<ReturnType<typeof searchUsersByName>>, TError = AxiosError<unknown>>(
 params: SearchUsersByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchUsersByNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getUsersByRole = (
    roleId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUsersByRole200>> => {
    
    
    return axios.default.get(
      `/api/users/role/${roleId}`,options
    );
  }




export const getGetUsersByRoleQueryKey = (roleId?: number,) => {
    return [
    `/api/users/role/${roleId}`
    ] as const;
    }

    
export const getGetUsersByRoleQueryOptions = <TData = Awaited<ReturnType<typeof getUsersByRole>>, TError = AxiosError<unknown>>(roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByRole>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersByRoleQueryKey(roleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersByRole>>> = ({ signal }) => getUsersByRole(roleId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(roleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersByRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersByRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersByRole>>>
export type GetUsersByRoleQueryError = AxiosError<unknown>


export function useGetUsersByRole<TData = Awaited<ReturnType<typeof getUsersByRole>>, TError = AxiosError<unknown>>(
 roleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersByRole>>,
          TError,
          Awaited<ReturnType<typeof getUsersByRole>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersByRole<TData = Awaited<ReturnType<typeof getUsersByRole>>, TError = AxiosError<unknown>>(
 roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersByRole>>,
          TError,
          Awaited<ReturnType<typeof getUsersByRole>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersByRole<TData = Awaited<ReturnType<typeof getUsersByRole>>, TError = AxiosError<unknown>>(
 roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByRole>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUsersByRole<TData = Awaited<ReturnType<typeof getUsersByRole>>, TError = AxiosError<unknown>>(
 roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByRole>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersByRoleQueryOptions(roleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Template generation not yet implemented
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const downloadTemplate = (
    entityType: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DownloadTemplate200>> => {
    
    
    return axios.default.get(
      `/api/upload/template/${entityType}`,options
    );
  }




export const getDownloadTemplateQueryKey = (entityType?: string,) => {
    return [
    `/api/upload/template/${entityType}`
    ] as const;
    }

    
export const getDownloadTemplateQueryOptions = <TData = Awaited<ReturnType<typeof downloadTemplate>>, TError = AxiosError<unknown>>(entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadTemplateQueryKey(entityType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTemplate>>> = ({ signal }) => downloadTemplate(entityType, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(entityType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof downloadTemplate>>>
export type DownloadTemplateQueryError = AxiosError<unknown>


export function useDownloadTemplate<TData = Awaited<ReturnType<typeof downloadTemplate>>, TError = AxiosError<unknown>>(
 entityType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadTemplate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTemplate<TData = Awaited<ReturnType<typeof downloadTemplate>>, TError = AxiosError<unknown>>(
 entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadTemplate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTemplate<TData = Awaited<ReturnType<typeof downloadTemplate>>, TError = AxiosError<unknown>>(
 entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */

export function useDownloadTemplate<TData = Awaited<ReturnType<typeof downloadTemplate>>, TError = AxiosError<unknown>>(
 entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadTemplateQueryOptions(entityType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Upload history not yet implemented
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */
export const getUploadHistory = (
    params?: GetUploadHistoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUploadHistory200>> => {
    
    
    return axios.default.get(
      `/api/upload/history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetUploadHistoryQueryKey = (params?: GetUploadHistoryParams,) => {
    return [
    `/api/upload/history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUploadHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getUploadHistory>>, TError = AxiosError<unknown>>(params?: GetUploadHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUploadHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadHistory>>> = ({ signal }) => getUploadHistory(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUploadHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUploadHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getUploadHistory>>>
export type GetUploadHistoryQueryError = AxiosError<unknown>


export function useGetUploadHistory<TData = Awaited<ReturnType<typeof getUploadHistory>>, TError = AxiosError<unknown>>(
 params: undefined |  GetUploadHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadHistory>>,
          TError,
          Awaited<ReturnType<typeof getUploadHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadHistory<TData = Awaited<ReturnType<typeof getUploadHistory>>, TError = AxiosError<unknown>>(
 params?: GetUploadHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadHistory>>,
          TError,
          Awaited<ReturnType<typeof getUploadHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadHistory<TData = Awaited<ReturnType<typeof getUploadHistory>>, TError = AxiosError<unknown>>(
 params?: GetUploadHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary DEPRECATED: Not yet available
 */

export function useGetUploadHistory<TData = Awaited<ReturnType<typeof getUploadHistory>>, TError = AxiosError<unknown>>(
 params?: GetUploadHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUploadHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAllServiceBreakdowns = (
    params?: GetAllServiceBreakdownsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseServiceBreakDownResponse>> => {
    
    
    return axios.default.get(
      `/api/servicebreakdown`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllServiceBreakdownsQueryKey = (params?: GetAllServiceBreakdownsParams,) => {
    return [
    `/api/servicebreakdown`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllServiceBreakdownsQueryOptions = <TData = Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError = AxiosError<unknown>>(params?: GetAllServiceBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllServiceBreakdownsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllServiceBreakdowns>>> = ({ signal }) => getAllServiceBreakdowns(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllServiceBreakdownsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllServiceBreakdowns>>>
export type GetAllServiceBreakdownsQueryError = AxiosError<unknown>


export function useGetAllServiceBreakdowns<TData = Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllServiceBreakdownsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceBreakdowns>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceBreakdowns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllServiceBreakdowns<TData = Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError = AxiosError<unknown>>(
 params?: GetAllServiceBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceBreakdowns>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceBreakdowns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllServiceBreakdowns<TData = Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError = AxiosError<unknown>>(
 params?: GetAllServiceBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllServiceBreakdowns<TData = Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError = AxiosError<unknown>>(
 params?: GetAllServiceBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceBreakdowns>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllServiceBreakdownsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getServiceBreakdownById = (
    serviceBreakdownId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceBreakDownResponse>> => {
    
    
    return axios.default.get(
      `/api/servicebreakdown/${serviceBreakdownId}`,options
    );
  }




export const getGetServiceBreakdownByIdQueryKey = (serviceBreakdownId?: number,) => {
    return [
    `/api/servicebreakdown/${serviceBreakdownId}`
    ] as const;
    }

    
export const getGetServiceBreakdownByIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceBreakdownById>>, TError = AxiosError<unknown>>(serviceBreakdownId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceBreakdownById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceBreakdownByIdQueryKey(serviceBreakdownId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceBreakdownById>>> = ({ signal }) => getServiceBreakdownById(serviceBreakdownId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(serviceBreakdownId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceBreakdownById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceBreakdownByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceBreakdownById>>>
export type GetServiceBreakdownByIdQueryError = AxiosError<unknown>


export function useGetServiceBreakdownById<TData = Awaited<ReturnType<typeof getServiceBreakdownById>>, TError = AxiosError<unknown>>(
 serviceBreakdownId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceBreakdownById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceBreakdownById>>,
          TError,
          Awaited<ReturnType<typeof getServiceBreakdownById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceBreakdownById<TData = Awaited<ReturnType<typeof getServiceBreakdownById>>, TError = AxiosError<unknown>>(
 serviceBreakdownId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceBreakdownById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceBreakdownById>>,
          TError,
          Awaited<ReturnType<typeof getServiceBreakdownById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceBreakdownById<TData = Awaited<ReturnType<typeof getServiceBreakdownById>>, TError = AxiosError<unknown>>(
 serviceBreakdownId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceBreakdownById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetServiceBreakdownById<TData = Awaited<ReturnType<typeof getServiceBreakdownById>>, TError = AxiosError<unknown>>(
 serviceBreakdownId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceBreakdownById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceBreakdownByIdQueryOptions(serviceBreakdownId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAllServiceAddOns = (
    params?: GetAllServiceAddOnsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseServiceAddOnResponse>> => {
    
    
    return axios.default.get(
      `/api/service-add-on`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllServiceAddOnsQueryKey = (params?: GetAllServiceAddOnsParams,) => {
    return [
    `/api/service-add-on`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllServiceAddOnsQueryOptions = <TData = Awaited<ReturnType<typeof getAllServiceAddOns>>, TError = AxiosError<unknown>>(params?: GetAllServiceAddOnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceAddOns>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllServiceAddOnsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllServiceAddOns>>> = ({ signal }) => getAllServiceAddOns(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllServiceAddOns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllServiceAddOnsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllServiceAddOns>>>
export type GetAllServiceAddOnsQueryError = AxiosError<unknown>


export function useGetAllServiceAddOns<TData = Awaited<ReturnType<typeof getAllServiceAddOns>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllServiceAddOnsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceAddOns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceAddOns>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceAddOns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllServiceAddOns<TData = Awaited<ReturnType<typeof getAllServiceAddOns>>, TError = AxiosError<unknown>>(
 params?: GetAllServiceAddOnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceAddOns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceAddOns>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceAddOns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllServiceAddOns<TData = Awaited<ReturnType<typeof getAllServiceAddOns>>, TError = AxiosError<unknown>>(
 params?: GetAllServiceAddOnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceAddOns>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllServiceAddOns<TData = Awaited<ReturnType<typeof getAllServiceAddOns>>, TError = AxiosError<unknown>>(
 params?: GetAllServiceAddOnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceAddOns>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllServiceAddOnsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getServiceAddOnById = (
    serviceAddOnId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ServiceAddOnResponse>> => {
    
    
    return axios.default.get(
      `/api/service-add-on/${serviceAddOnId}`,options
    );
  }




export const getGetServiceAddOnByIdQueryKey = (serviceAddOnId?: number,) => {
    return [
    `/api/service-add-on/${serviceAddOnId}`
    ] as const;
    }

    
export const getGetServiceAddOnByIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceAddOnById>>, TError = AxiosError<unknown>>(serviceAddOnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAddOnById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAddOnByIdQueryKey(serviceAddOnId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAddOnById>>> = ({ signal }) => getServiceAddOnById(serviceAddOnId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(serviceAddOnId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceAddOnById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceAddOnByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAddOnById>>>
export type GetServiceAddOnByIdQueryError = AxiosError<unknown>


export function useGetServiceAddOnById<TData = Awaited<ReturnType<typeof getServiceAddOnById>>, TError = AxiosError<unknown>>(
 serviceAddOnId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAddOnById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAddOnById>>,
          TError,
          Awaited<ReturnType<typeof getServiceAddOnById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAddOnById<TData = Awaited<ReturnType<typeof getServiceAddOnById>>, TError = AxiosError<unknown>>(
 serviceAddOnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAddOnById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAddOnById>>,
          TError,
          Awaited<ReturnType<typeof getServiceAddOnById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAddOnById<TData = Awaited<ReturnType<typeof getServiceAddOnById>>, TError = AxiosError<unknown>>(
 serviceAddOnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAddOnById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetServiceAddOnById<TData = Awaited<ReturnType<typeof getServiceAddOnById>>, TError = AxiosError<unknown>>(
 serviceAddOnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAddOnById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAddOnByIdQueryOptions(serviceAddOnId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAllRooms = (
    params?: GetAllRoomsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseRoomResponse>> => {
    
    
    return axios.default.get(
      `/api/room`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllRoomsQueryKey = (params?: GetAllRoomsParams,) => {
    return [
    `/api/room`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllRoomsQueryOptions = <TData = Awaited<ReturnType<typeof getAllRooms>>, TError = AxiosError<unknown>>(params?: GetAllRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRooms>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllRoomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllRooms>>> = ({ signal }) => getAllRooms(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllRooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllRooms>>>
export type GetAllRoomsQueryError = AxiosError<unknown>


export function useGetAllRooms<TData = Awaited<ReturnType<typeof getAllRooms>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllRoomsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRooms>>,
          TError,
          Awaited<ReturnType<typeof getAllRooms>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRooms<TData = Awaited<ReturnType<typeof getAllRooms>>, TError = AxiosError<unknown>>(
 params?: GetAllRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRooms>>,
          TError,
          Awaited<ReturnType<typeof getAllRooms>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRooms<TData = Awaited<ReturnType<typeof getAllRooms>>, TError = AxiosError<unknown>>(
 params?: GetAllRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRooms>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllRooms<TData = Awaited<ReturnType<typeof getAllRooms>>, TError = AxiosError<unknown>>(
 params?: GetAllRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRooms>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllRoomsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getRoomById = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RoomResponse>> => {
    
    
    return axios.default.get(
      `/api/room/${id}`,options
    );
  }




export const getGetRoomByIdQueryKey = (id?: number,) => {
    return [
    `/api/room/${id}`
    ] as const;
    }

    
export const getGetRoomByIdQueryOptions = <TData = Awaited<ReturnType<typeof getRoomById>>, TError = AxiosError<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoomByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoomById>>> = ({ signal }) => getRoomById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoomById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoomByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRoomById>>>
export type GetRoomByIdQueryError = AxiosError<unknown>


export function useGetRoomById<TData = Awaited<ReturnType<typeof getRoomById>>, TError = AxiosError<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoomById>>,
          TError,
          Awaited<ReturnType<typeof getRoomById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoomById<TData = Awaited<ReturnType<typeof getRoomById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoomById>>,
          TError,
          Awaited<ReturnType<typeof getRoomById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoomById<TData = Awaited<ReturnType<typeof getRoomById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRoomById<TData = Awaited<ReturnType<typeof getRoomById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoomByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteRoom = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteRoom200>> => {
    
    
    return axios.default.delete(
      `/api/room/${id}`,options
    );
  }



export const getDeleteRoomMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoom>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoom>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteRoom'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRoom(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoomMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoom>>>
    
    export type DeleteRoomMutationError = AxiosError<unknown>

    export const useDeleteRoom = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoom>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoom>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteRoomMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAllRates = (
    params?: GetAllRatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseRateResponse>> => {
    
    
    return axios.default.get(
      `/api/rate`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllRatesQueryKey = (params?: GetAllRatesParams,) => {
    return [
    `/api/rate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllRatesQueryOptions = <TData = Awaited<ReturnType<typeof getAllRates>>, TError = AxiosError<unknown>>(params?: GetAllRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRates>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllRatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllRates>>> = ({ signal }) => getAllRates(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllRates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllRates>>>
export type GetAllRatesQueryError = AxiosError<unknown>


export function useGetAllRates<TData = Awaited<ReturnType<typeof getAllRates>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllRatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRates>>,
          TError,
          Awaited<ReturnType<typeof getAllRates>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRates<TData = Awaited<ReturnType<typeof getAllRates>>, TError = AxiosError<unknown>>(
 params?: GetAllRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRates>>,
          TError,
          Awaited<ReturnType<typeof getAllRates>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRates<TData = Awaited<ReturnType<typeof getAllRates>>, TError = AxiosError<unknown>>(
 params?: GetAllRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRates>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllRates<TData = Awaited<ReturnType<typeof getAllRates>>, TError = AxiosError<unknown>>(
 params?: GetAllRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRates>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllRatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getRate = (
    rateId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RateResponse>> => {
    
    
    return axios.default.get(
      `/api/rate/${rateId}`,options
    );
  }




export const getGetRateQueryKey = (rateId?: number,) => {
    return [
    `/api/rate/${rateId}`
    ] as const;
    }

    
export const getGetRateQueryOptions = <TData = Awaited<ReturnType<typeof getRate>>, TError = AxiosError<unknown>>(rateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRate>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRateQueryKey(rateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRate>>> = ({ signal }) => getRate(rateId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(rateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRateQueryResult = NonNullable<Awaited<ReturnType<typeof getRate>>>
export type GetRateQueryError = AxiosError<unknown>


export function useGetRate<TData = Awaited<ReturnType<typeof getRate>>, TError = AxiosError<unknown>>(
 rateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRate>>,
          TError,
          Awaited<ReturnType<typeof getRate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRate<TData = Awaited<ReturnType<typeof getRate>>, TError = AxiosError<unknown>>(
 rateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRate>>,
          TError,
          Awaited<ReturnType<typeof getRate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRate<TData = Awaited<ReturnType<typeof getRate>>, TError = AxiosError<unknown>>(
 rateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRate>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRate<TData = Awaited<ReturnType<typeof getRate>>, TError = AxiosError<unknown>>(
 rateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRate>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRateQueryOptions(rateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns all payments recorded against a booking
 * @summary Get payment history
 */
export const getBookingPayments = (
    bookingId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaymentResponse[]>> => {
    
    
    return axios.default.get(
      `/api/payments/booking/${bookingId}`,options
    );
  }




export const getGetBookingPaymentsQueryKey = (bookingId?: number,) => {
    return [
    `/api/payments/booking/${bookingId}`
    ] as const;
    }

    
export const getGetBookingPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getBookingPayments>>, TError = AxiosError<unknown>>(bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPayments>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingPaymentsQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingPayments>>> = ({ signal }) => getBookingPayments(bookingId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingPayments>>>
export type GetBookingPaymentsQueryError = AxiosError<unknown>


export function useGetBookingPayments<TData = Awaited<ReturnType<typeof getBookingPayments>>, TError = AxiosError<unknown>>(
 bookingId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingPayments>>,
          TError,
          Awaited<ReturnType<typeof getBookingPayments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingPayments<TData = Awaited<ReturnType<typeof getBookingPayments>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingPayments>>,
          TError,
          Awaited<ReturnType<typeof getBookingPayments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingPayments<TData = Awaited<ReturnType<typeof getBookingPayments>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPayments>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment history
 */

export function useGetBookingPayments<TData = Awaited<ReturnType<typeof getBookingPayments>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPayments>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingPaymentsQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the payment summary for a booking
 * @summary Get payment summary
 */
export const getPaymentSummary = (
    bookingId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaymentSummaryDTO>> => {
    
    
    return axios.default.get(
      `/api/payments/booking/${bookingId}/summary`,options
    );
  }




export const getGetPaymentSummaryQueryKey = (bookingId?: number,) => {
    return [
    `/api/payments/booking/${bookingId}/summary`
    ] as const;
    }

    
export const getGetPaymentSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentSummary>>, TError = AxiosError<unknown>>(bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSummary>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentSummaryQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentSummary>>> = ({ signal }) => getPaymentSummary(bookingId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentSummary>>>
export type GetPaymentSummaryQueryError = AxiosError<unknown>


export function useGetPaymentSummary<TData = Awaited<ReturnType<typeof getPaymentSummary>>, TError = AxiosError<unknown>>(
 bookingId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentSummary>>,
          TError,
          Awaited<ReturnType<typeof getPaymentSummary>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentSummary<TData = Awaited<ReturnType<typeof getPaymentSummary>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentSummary>>,
          TError,
          Awaited<ReturnType<typeof getPaymentSummary>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentSummary<TData = Awaited<ReturnType<typeof getPaymentSummary>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSummary>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment summary
 */

export function useGetPaymentSummary<TData = Awaited<ReturnType<typeof getPaymentSummary>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentSummary>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentSummaryQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listMealsRffs = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRffResponse[]>> => {
    
    
    return axios.default.get(
      `/api/meals/rff-payments`,options
    );
  }




export const getListMealsRffsQueryKey = () => {
    return [
    `/api/meals/rff-payments`
    ] as const;
    }

    
export const getListMealsRffsQueryOptions = <TData = Awaited<ReturnType<typeof listMealsRffs>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMealsRffs>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMealsRffsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMealsRffs>>> = ({ signal }) => listMealsRffs({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMealsRffs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMealsRffsQueryResult = NonNullable<Awaited<ReturnType<typeof listMealsRffs>>>
export type ListMealsRffsQueryError = AxiosError<unknown>


export function useListMealsRffs<TData = Awaited<ReturnType<typeof listMealsRffs>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMealsRffs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMealsRffs>>,
          TError,
          Awaited<ReturnType<typeof listMealsRffs>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMealsRffs<TData = Awaited<ReturnType<typeof listMealsRffs>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMealsRffs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMealsRffs>>,
          TError,
          Awaited<ReturnType<typeof listMealsRffs>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMealsRffs<TData = Awaited<ReturnType<typeof listMealsRffs>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMealsRffs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMealsRffs<TData = Awaited<ReturnType<typeof listMealsRffs>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMealsRffs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMealsRffsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getTracker = (
    rffId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetTracker200Item[]>> => {
    
    
    return axios.default.get(
      `/api/meals/rff-payments/${rffId}/tracker`,options
    );
  }




export const getGetTrackerQueryKey = (rffId?: number,) => {
    return [
    `/api/meals/rff-payments/${rffId}/tracker`
    ] as const;
    }

    
export const getGetTrackerQueryOptions = <TData = Awaited<ReturnType<typeof getTracker>>, TError = AxiosError<unknown>>(rffId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracker>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackerQueryKey(rffId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracker>>> = ({ signal }) => getTracker(rffId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(rffId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTracker>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackerQueryResult = NonNullable<Awaited<ReturnType<typeof getTracker>>>
export type GetTrackerQueryError = AxiosError<unknown>


export function useGetTracker<TData = Awaited<ReturnType<typeof getTracker>>, TError = AxiosError<unknown>>(
 rffId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracker>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTracker>>,
          TError,
          Awaited<ReturnType<typeof getTracker>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTracker<TData = Awaited<ReturnType<typeof getTracker>>, TError = AxiosError<unknown>>(
 rffId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracker>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTracker>>,
          TError,
          Awaited<ReturnType<typeof getTracker>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTracker<TData = Awaited<ReturnType<typeof getTracker>>, TError = AxiosError<unknown>>(
 rffId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracker>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTracker<TData = Awaited<ReturnType<typeof getTracker>>, TError = AxiosError<unknown>>(
 rffId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracker>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackerQueryOptions(rffId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listEmergencyInvoices = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealInvoiceResponse[]>> => {
    
    
    return axios.default.get(
      `/api/meals/rff-payments/emergency-invoices`,options
    );
  }




export const getListEmergencyInvoicesQueryKey = () => {
    return [
    `/api/meals/rff-payments/emergency-invoices`
    ] as const;
    }

    
export const getListEmergencyInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listEmergencyInvoices>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmergencyInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmergencyInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmergencyInvoices>>> = ({ signal }) => listEmergencyInvoices({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmergencyInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmergencyInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmergencyInvoices>>>
export type ListEmergencyInvoicesQueryError = AxiosError<unknown>


export function useListEmergencyInvoices<TData = Awaited<ReturnType<typeof listEmergencyInvoices>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmergencyInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmergencyInvoices>>,
          TError,
          Awaited<ReturnType<typeof listEmergencyInvoices>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmergencyInvoices<TData = Awaited<ReturnType<typeof listEmergencyInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmergencyInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmergencyInvoices>>,
          TError,
          Awaited<ReturnType<typeof listEmergencyInvoices>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmergencyInvoices<TData = Awaited<ReturnType<typeof listEmergencyInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmergencyInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEmergencyInvoices<TData = Awaited<ReturnType<typeof listEmergencyInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmergencyInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmergencyInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getBudgetLines = (
    invoiceId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRffBudgetLineResponse[]>> => {
    
    
    return axios.default.get(
      `/api/meals/rff-payments/emergency-invoices/${invoiceId}/budget-lines`,options
    );
  }




export const getGetBudgetLinesQueryKey = (invoiceId?: number,) => {
    return [
    `/api/meals/rff-payments/emergency-invoices/${invoiceId}/budget-lines`
    ] as const;
    }

    
export const getGetBudgetLinesQueryOptions = <TData = Awaited<ReturnType<typeof getBudgetLines>>, TError = AxiosError<unknown>>(invoiceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetLines>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBudgetLinesQueryKey(invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBudgetLines>>> = ({ signal }) => getBudgetLines(invoiceId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBudgetLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBudgetLinesQueryResult = NonNullable<Awaited<ReturnType<typeof getBudgetLines>>>
export type GetBudgetLinesQueryError = AxiosError<unknown>


export function useGetBudgetLines<TData = Awaited<ReturnType<typeof getBudgetLines>>, TError = AxiosError<unknown>>(
 invoiceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBudgetLines>>,
          TError,
          Awaited<ReturnType<typeof getBudgetLines>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBudgetLines<TData = Awaited<ReturnType<typeof getBudgetLines>>, TError = AxiosError<unknown>>(
 invoiceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBudgetLines>>,
          TError,
          Awaited<ReturnType<typeof getBudgetLines>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBudgetLines<TData = Awaited<ReturnType<typeof getBudgetLines>>, TError = AxiosError<unknown>>(
 invoiceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetLines>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBudgetLines<TData = Awaited<ReturnType<typeof getBudgetLines>>, TError = AxiosError<unknown>>(
 invoiceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetLines>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBudgetLinesQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the authenticated user's meal requests with pagination.
 * @summary List my meal requests
 */
export const getMyRequests = (
    params?: GetMyRequestsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseMealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetMyRequestsQueryKey = (params?: GetMyRequestsParams,) => {
    return [
    `/api/meals/requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMyRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getMyRequests>>, TError = AxiosError<unknown>>(params?: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRequests>>> = ({ signal }) => getMyRequests(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRequests>>>
export type GetMyRequestsQueryError = AxiosError<unknown>


export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = AxiosError<unknown>>(
 params: undefined |  GetMyRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyRequests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = AxiosError<unknown>>(
 params?: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyRequests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = AxiosError<unknown>>(
 params?: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List my meal requests
 */

export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = AxiosError<unknown>>(
 params?: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the details of a single meal request owned by the authenticated user.
 * @summary Get one of my meal requests
 */
export const getRequestById = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/${requestId}`,options
    );
  }




export const getGetRequestByIdQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/${requestId}`
    ] as const;
    }

    
export const getGetRequestByIdQueryOptions = <TData = Awaited<ReturnType<typeof getRequestById>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestByIdQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestById>>> = ({ signal }) => getRequestById(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestById>>>
export type GetRequestByIdQueryError = AxiosError<unknown>


export function useGetRequestById<TData = Awaited<ReturnType<typeof getRequestById>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestById>>,
          TError,
          Awaited<ReturnType<typeof getRequestById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestById<TData = Awaited<ReturnType<typeof getRequestById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestById>>,
          TError,
          Awaited<ReturnType<typeof getRequestById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestById<TData = Awaited<ReturnType<typeof getRequestById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one of my meal requests
 */

export function useGetRequestById<TData = Awaited<ReturnType<typeof getRequestById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestByIdQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the generated invoice for the given meal request. Only visible to Meals Admin before sending.
 * @summary Preview invoice (Meals Admin)
 */
export const getInvoice = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealInvoiceResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/${requestId}/invoice`,options
    );
  }




export const getGetInvoiceQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/${requestId}/invoice`
    ] as const;
    }

    
export const getGetInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoice>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({ signal }) => getInvoice(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetInvoiceQueryError = AxiosError<unknown>


export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview invoice (Meals Admin)
 */

export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the invoice for a meal request, but only after the Meals Admin has sent it. Requires HOD proxy headers.
 * @summary View invoice (HOD)
 */
export const getHodInvoice = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealInvoiceResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/${requestId}/invoice/hod`,options
    );
  }




export const getGetHodInvoiceQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/${requestId}/invoice/hod`
    ] as const;
    }

    
export const getGetHodInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getHodInvoice>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHodInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHodInvoiceQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHodInvoice>>> = ({ signal }) => getHodInvoice(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHodInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHodInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getHodInvoice>>>
export type GetHodInvoiceQueryError = AxiosError<unknown>


export function useGetHodInvoice<TData = Awaited<ReturnType<typeof getHodInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHodInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHodInvoice>>,
          TError,
          Awaited<ReturnType<typeof getHodInvoice>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHodInvoice<TData = Awaited<ReturnType<typeof getHodInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHodInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHodInvoice>>,
          TError,
          Awaited<ReturnType<typeof getHodInvoice>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHodInvoice<TData = Awaited<ReturnType<typeof getHodInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHodInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary View invoice (HOD)
 */

export function useGetHodInvoice<TData = Awaited<ReturnType<typeof getHodInvoice>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHodInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHodInvoiceQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Searches MIS staff records so requesters can attach Alpha users as meal-request participants.
 * @summary Search Alpha staff participants for meal requests
 */
export const searchParticipants = (
    params: SearchParticipantsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestParticipantPayload[]>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/participants/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getSearchParticipantsQueryKey = (params?: SearchParticipantsParams,) => {
    return [
    `/api/meals/requests/participants/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof searchParticipants>>, TError = AxiosError<unknown>>(params: SearchParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchParticipants>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchParticipantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchParticipants>>> = ({ signal }) => searchParticipants(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof searchParticipants>>>
export type SearchParticipantsQueryError = AxiosError<unknown>


export function useSearchParticipants<TData = Awaited<ReturnType<typeof searchParticipants>>, TError = AxiosError<unknown>>(
 params: SearchParticipantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchParticipants>>,
          TError,
          Awaited<ReturnType<typeof searchParticipants>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchParticipants<TData = Awaited<ReturnType<typeof searchParticipants>>, TError = AxiosError<unknown>>(
 params: SearchParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchParticipants>>,
          TError,
          Awaited<ReturnType<typeof searchParticipants>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchParticipants<TData = Awaited<ReturnType<typeof searchParticipants>>, TError = AxiosError<unknown>>(
 params: SearchParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchParticipants>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search Alpha staff participants for meal requests
 */

export function useSearchParticipants<TData = Awaited<ReturnType<typeof searchParticipants>>, TError = AxiosError<unknown>>(
 params: SearchParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchParticipants>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchParticipantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns pending task counts for the authenticated user's role (HOD approvals, Meals Admin queue).
 * @summary Get pending meal request counts for dashboard
 */
export const getPendingDashboardCounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPendingDashboardCounts200Item[]>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/dashboard/pending-counts`,options
    );
  }




export const getGetPendingDashboardCountsQueryKey = () => {
    return [
    `/api/meals/requests/dashboard/pending-counts`
    ] as const;
    }

    
export const getGetPendingDashboardCountsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDashboardCountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDashboardCounts>>> = ({ signal }) => getPendingDashboardCounts({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingDashboardCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDashboardCounts>>>
export type GetPendingDashboardCountsQueryError = AxiosError<unknown>


export function useGetPendingDashboardCounts<TData = Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDashboardCounts>>,
          TError,
          Awaited<ReturnType<typeof getPendingDashboardCounts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingDashboardCounts<TData = Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDashboardCounts>>,
          TError,
          Awaited<ReturnType<typeof getPendingDashboardCounts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingDashboardCounts<TData = Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pending meal request counts for dashboard
 */

export function useGetPendingDashboardCounts<TData = Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDashboardCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingDashboardCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the pending meal requests for the HOD's department.
 * @summary List meal requests pending HOD approval
 */
export const getPendingHodApprovals = (
    params?: GetPendingHodApprovalsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseMealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetPendingHodApprovalsQueryKey = (params?: GetPendingHodApprovalsParams,) => {
    return [
    `/api/meals/requests/approvals/hod`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPendingHodApprovalsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingHodApprovals>>, TError = AxiosError<unknown>>(params?: GetPendingHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingHodApprovalsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingHodApprovals>>> = ({ signal }) => getPendingHodApprovals(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingHodApprovalsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingHodApprovals>>>
export type GetPendingHodApprovalsQueryError = AxiosError<unknown>


export function useGetPendingHodApprovals<TData = Awaited<ReturnType<typeof getPendingHodApprovals>>, TError = AxiosError<unknown>>(
 params: undefined |  GetPendingHodApprovalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingHodApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingHodApprovals>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingHodApprovals<TData = Awaited<ReturnType<typeof getPendingHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetPendingHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingHodApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingHodApprovals>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingHodApprovals<TData = Awaited<ReturnType<typeof getPendingHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetPendingHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal requests pending HOD approval
 */

export function useGetPendingHodApprovals<TData = Awaited<ReturnType<typeof getPendingHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetPendingHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingHodApprovalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns one department meal request for HOD review.
 * @summary Get one meal request pending HOD approval
 */
export const getPendingHodApprovalById = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod/${requestId}`,options
    );
  }




export const getGetPendingHodApprovalByIdQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/approvals/hod/${requestId}`
    ] as const;
    }

    
export const getGetPendingHodApprovalByIdQueryOptions = <TData = Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingHodApprovalByIdQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingHodApprovalById>>> = ({ signal }) => getPendingHodApprovalById(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingHodApprovalByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingHodApprovalById>>>
export type GetPendingHodApprovalByIdQueryError = AxiosError<unknown>


export function useGetPendingHodApprovalById<TData = Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingHodApprovalById>>,
          TError,
          Awaited<ReturnType<typeof getPendingHodApprovalById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingHodApprovalById<TData = Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingHodApprovalById>>,
          TError,
          Awaited<ReturnType<typeof getPendingHodApprovalById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingHodApprovalById<TData = Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal request pending HOD approval
 */

export function useGetPendingHodApprovalById<TData = Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingHodApprovalByIdQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the department meal requests already rejected by the authenticated HOD.
 * @summary List meal requests rejected by the HOD
 */
export const getRejectedHodApprovals = (
    params?: GetRejectedHodApprovalsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseMealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod/rejected`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetRejectedHodApprovalsQueryKey = (params?: GetRejectedHodApprovalsParams,) => {
    return [
    `/api/meals/requests/approvals/hod/rejected`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetRejectedHodApprovalsQueryOptions = <TData = Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError = AxiosError<unknown>>(params?: GetRejectedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRejectedHodApprovalsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRejectedHodApprovals>>> = ({ signal }) => getRejectedHodApprovals(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRejectedHodApprovalsQueryResult = NonNullable<Awaited<ReturnType<typeof getRejectedHodApprovals>>>
export type GetRejectedHodApprovalsQueryError = AxiosError<unknown>


export function useGetRejectedHodApprovals<TData = Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError = AxiosError<unknown>>(
 params: undefined |  GetRejectedHodApprovalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRejectedHodApprovals>>,
          TError,
          Awaited<ReturnType<typeof getRejectedHodApprovals>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRejectedHodApprovals<TData = Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetRejectedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRejectedHodApprovals>>,
          TError,
          Awaited<ReturnType<typeof getRejectedHodApprovals>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRejectedHodApprovals<TData = Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetRejectedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal requests rejected by the HOD
 */

export function useGetRejectedHodApprovals<TData = Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetRejectedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRejectedHodApprovalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns one department meal request already rejected by the authenticated HOD.
 * @summary Get one meal request rejected by the HOD
 */
export const getRejectedHodApprovalById = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod/rejected/${requestId}`,options
    );
  }




export const getGetRejectedHodApprovalByIdQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/approvals/hod/rejected/${requestId}`
    ] as const;
    }

    
export const getGetRejectedHodApprovalByIdQueryOptions = <TData = Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRejectedHodApprovalByIdQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRejectedHodApprovalById>>> = ({ signal }) => getRejectedHodApprovalById(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRejectedHodApprovalByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRejectedHodApprovalById>>>
export type GetRejectedHodApprovalByIdQueryError = AxiosError<unknown>


export function useGetRejectedHodApprovalById<TData = Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRejectedHodApprovalById>>,
          TError,
          Awaited<ReturnType<typeof getRejectedHodApprovalById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRejectedHodApprovalById<TData = Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRejectedHodApprovalById>>,
          TError,
          Awaited<ReturnType<typeof getRejectedHodApprovalById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRejectedHodApprovalById<TData = Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal request rejected by the HOD
 */

export function useGetRejectedHodApprovalById<TData = Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRejectedHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRejectedHodApprovalByIdQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the department meal requests already approved by the authenticated HOD.
 * @summary List meal requests approved by the HOD
 */
export const getApprovedHodApprovals = (
    params?: GetApprovedHodApprovalsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseMealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod/approved`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApprovedHodApprovalsQueryKey = (params?: GetApprovedHodApprovalsParams,) => {
    return [
    `/api/meals/requests/approvals/hod/approved`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApprovedHodApprovalsQueryOptions = <TData = Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError = AxiosError<unknown>>(params?: GetApprovedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovedHodApprovalsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovedHodApprovals>>> = ({ signal }) => getApprovedHodApprovals(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovedHodApprovalsQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovedHodApprovals>>>
export type GetApprovedHodApprovalsQueryError = AxiosError<unknown>


export function useGetApprovedHodApprovals<TData = Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError = AxiosError<unknown>>(
 params: undefined |  GetApprovedHodApprovalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedHodApprovals>>,
          TError,
          Awaited<ReturnType<typeof getApprovedHodApprovals>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovedHodApprovals<TData = Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetApprovedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedHodApprovals>>,
          TError,
          Awaited<ReturnType<typeof getApprovedHodApprovals>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovedHodApprovals<TData = Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetApprovedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meal requests approved by the HOD
 */

export function useGetApprovedHodApprovals<TData = Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError = AxiosError<unknown>>(
 params?: GetApprovedHodApprovalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApprovedHodApprovalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns one department meal request already approved by the authenticated HOD.
 * @summary Get one meal request approved by the HOD
 */
export const getApprovedHodApprovalById = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod/approved/${requestId}`,options
    );
  }




export const getGetApprovedHodApprovalByIdQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/approvals/hod/approved/${requestId}`
    ] as const;
    }

    
export const getGetApprovedHodApprovalByIdQueryOptions = <TData = Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovedHodApprovalByIdQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovedHodApprovalById>>> = ({ signal }) => getApprovedHodApprovalById(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovedHodApprovalByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovedHodApprovalById>>>
export type GetApprovedHodApprovalByIdQueryError = AxiosError<unknown>


export function useGetApprovedHodApprovalById<TData = Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedHodApprovalById>>,
          TError,
          Awaited<ReturnType<typeof getApprovedHodApprovalById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovedHodApprovalById<TData = Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedHodApprovalById>>,
          TError,
          Awaited<ReturnType<typeof getApprovedHodApprovalById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovedHodApprovalById<TData = Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal request approved by the HOD
 */

export function useGetApprovedHodApprovalById<TData = Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedHodApprovalById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApprovedHodApprovalByIdQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns whether the MIS proxy user can access the meals approvals queue.
 * @summary Check meals approval access
 */
export const getApprovalAccess = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetApprovalAccess200>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/approvals/hod/access`,options
    );
  }




export const getGetApprovalAccessQueryKey = () => {
    return [
    `/api/meals/requests/approvals/hod/access`
    ] as const;
    }

    
export const getGetApprovalAccessQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalAccess>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalAccess>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalAccessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalAccess>>> = ({ signal }) => getApprovalAccess({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovalAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovalAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalAccess>>>
export type GetApprovalAccessQueryError = AxiosError<unknown>


export function useGetApprovalAccess<TData = Awaited<ReturnType<typeof getApprovalAccess>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalAccess>>,
          TError,
          Awaited<ReturnType<typeof getApprovalAccess>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalAccess<TData = Awaited<ReturnType<typeof getApprovalAccess>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalAccess>>,
          TError,
          Awaited<ReturnType<typeof getApprovalAccess>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalAccess<TData = Awaited<ReturnType<typeof getApprovalAccess>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalAccess>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check meals approval access
 */

export function useGetApprovalAccess<TData = Awaited<ReturnType<typeof getApprovalAccess>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalAccess>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApprovalAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the full meals request queue for guest-house administrators and meals officers.
 * @summary List all meal requests for meals admins
 */
export const getAllRequestsForMealsAdmin = (
    params?: GetAllRequestsForMealsAdminParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseMealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/admin`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllRequestsForMealsAdminQueryKey = (params?: GetAllRequestsForMealsAdminParams,) => {
    return [
    `/api/meals/requests/admin`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllRequestsForMealsAdminQueryOptions = <TData = Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError = AxiosError<unknown>>(params?: GetAllRequestsForMealsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllRequestsForMealsAdminQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>> = ({ signal }) => getAllRequestsForMealsAdmin(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllRequestsForMealsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>>
export type GetAllRequestsForMealsAdminQueryError = AxiosError<unknown>


export function useGetAllRequestsForMealsAdmin<TData = Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllRequestsForMealsAdminParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRequestsForMealsAdmin<TData = Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError = AxiosError<unknown>>(
 params?: GetAllRequestsForMealsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRequestsForMealsAdmin<TData = Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError = AxiosError<unknown>>(
 params?: GetAllRequestsForMealsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all meal requests for meals admins
 */

export function useGetAllRequestsForMealsAdmin<TData = Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError = AxiosError<unknown>>(
 params?: GetAllRequestsForMealsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRequestsForMealsAdmin>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllRequestsForMealsAdminQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the details of any meal request for guest-house administrators and meals officers.
 * @summary Get one meal request for meals admins
 */
export const getRequestByIdForMealsAdmin = (
    requestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealRequestResponse>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/admin/${requestId}`,options
    );
  }




export const getGetRequestByIdForMealsAdminQueryKey = (requestId?: number,) => {
    return [
    `/api/meals/requests/admin/${requestId}`
    ] as const;
    }

    
export const getGetRequestByIdForMealsAdminQueryOptions = <TData = Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError = AxiosError<unknown>>(requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestByIdForMealsAdminQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>> = ({ signal }) => getRequestByIdForMealsAdmin(requestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestByIdForMealsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>>
export type GetRequestByIdForMealsAdminQueryError = AxiosError<unknown>


export function useGetRequestByIdForMealsAdmin<TData = Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError = AxiosError<unknown>>(
 requestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestByIdForMealsAdmin<TData = Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestByIdForMealsAdmin<TData = Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one meal request for meals admins
 */

export function useGetRequestByIdForMealsAdmin<TData = Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError = AxiosError<unknown>>(
 requestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestByIdForMealsAdmin>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestByIdForMealsAdminQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns faculties, departments, and other requesting units from MIS so Meals Admin can raise emergency meal requests on behalf of the correct unit.
 * @summary Search MIS request units for emergency meal requests
 */
export const searchRequestUnitsForEmergencyRequests = (
    params?: SearchRequestUnitsForEmergencyRequestsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestUnitSearchResultDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/requests/admin/request-units/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getSearchRequestUnitsForEmergencyRequestsQueryKey = (params?: SearchRequestUnitsForEmergencyRequestsParams,) => {
    return [
    `/api/meals/requests/admin/request-units/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchRequestUnitsForEmergencyRequestsQueryOptions = <TData = Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError = AxiosError<unknown>>(params?: SearchRequestUnitsForEmergencyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchRequestUnitsForEmergencyRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>> = ({ signal }) => searchRequestUnitsForEmergencyRequests(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchRequestUnitsForEmergencyRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>>
export type SearchRequestUnitsForEmergencyRequestsQueryError = AxiosError<unknown>


export function useSearchRequestUnitsForEmergencyRequests<TData = Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError = AxiosError<unknown>>(
 params: undefined |  SearchRequestUnitsForEmergencyRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>,
          TError,
          Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchRequestUnitsForEmergencyRequests<TData = Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError = AxiosError<unknown>>(
 params?: SearchRequestUnitsForEmergencyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>,
          TError,
          Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchRequestUnitsForEmergencyRequests<TData = Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError = AxiosError<unknown>>(
 params?: SearchRequestUnitsForEmergencyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search MIS request units for emergency meal requests
 */

export function useSearchRequestUnitsForEmergencyRequests<TData = Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError = AxiosError<unknown>>(
 params?: SearchRequestUnitsForEmergencyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchRequestUnitsForEmergencyRequests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchRequestUnitsForEmergencyRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns all invoices sent to the HOD's department. Requires HOD proxy department id header.
 * @summary List invoices sent to HOD
 */
export const listHodInvoices = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MealInvoiceResponse[]>> => {
    
    
    return axios.default.get(
      `/api/meals/invoices/hod`,options
    );
  }




export const getListHodInvoicesQueryKey = () => {
    return [
    `/api/meals/invoices/hod`
    ] as const;
    }

    
export const getListHodInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listHodInvoices>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHodInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHodInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHodInvoices>>> = ({ signal }) => listHodInvoices({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHodInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListHodInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listHodInvoices>>>
export type ListHodInvoicesQueryError = AxiosError<unknown>


export function useListHodInvoices<TData = Awaited<ReturnType<typeof listHodInvoices>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHodInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHodInvoices>>,
          TError,
          Awaited<ReturnType<typeof listHodInvoices>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListHodInvoices<TData = Awaited<ReturnType<typeof listHodInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHodInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHodInvoices>>,
          TError,
          Awaited<ReturnType<typeof listHodInvoices>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListHodInvoices<TData = Awaited<ReturnType<typeof listHodInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHodInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List invoices sent to HOD
 */

export function useListHodInvoices<TData = Awaited<ReturnType<typeof listHodInvoices>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHodInvoices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListHodInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the workflow definition currently applied to newly submitted meal requests.
 * @summary Get the active workflow configuration
 */
export const getActiveWorkflow = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkflowConfigurationDto>> => {
    
    
    return axios.default.get(
      `/api/meals/config/workflows/active`,options
    );
  }




export const getGetActiveWorkflowQueryKey = () => {
    return [
    `/api/meals/config/workflows/active`
    ] as const;
    }

    
export const getGetActiveWorkflowQueryOptions = <TData = Awaited<ReturnType<typeof getActiveWorkflow>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveWorkflow>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveWorkflowQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveWorkflow>>> = ({ signal }) => getActiveWorkflow({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveWorkflow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveWorkflowQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveWorkflow>>>
export type GetActiveWorkflowQueryError = AxiosError<unknown>


export function useGetActiveWorkflow<TData = Awaited<ReturnType<typeof getActiveWorkflow>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveWorkflow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getActiveWorkflow>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveWorkflow<TData = Awaited<ReturnType<typeof getActiveWorkflow>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveWorkflow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getActiveWorkflow>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveWorkflow<TData = Awaited<ReturnType<typeof getActiveWorkflow>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveWorkflow>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the active workflow configuration
 */

export function useGetActiveWorkflow<TData = Awaited<ReturnType<typeof getActiveWorkflow>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveWorkflow>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveWorkflowQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns staff users from MIS that can be selected as explicit approvers on workflow steps.
 * @summary Search MIS staff for workflow approver selection
 */
export const searchWorkflowApproverStaff = (
    params: SearchWorkflowApproverStaffParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkflowApproverSearchResultDto[]>> => {
    
    
    return axios.default.get(
      `/api/meals/config/workflow-approvers/staff-search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getSearchWorkflowApproverStaffQueryKey = (params?: SearchWorkflowApproverStaffParams,) => {
    return [
    `/api/meals/config/workflow-approvers/staff-search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchWorkflowApproverStaffQueryOptions = <TData = Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError = AxiosError<unknown>>(params: SearchWorkflowApproverStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchWorkflowApproverStaffQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>> = ({ signal }) => searchWorkflowApproverStaff(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchWorkflowApproverStaffQueryResult = NonNullable<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>>
export type SearchWorkflowApproverStaffQueryError = AxiosError<unknown>


export function useSearchWorkflowApproverStaff<TData = Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError = AxiosError<unknown>>(
 params: SearchWorkflowApproverStaffParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchWorkflowApproverStaff>>,
          TError,
          Awaited<ReturnType<typeof searchWorkflowApproverStaff>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchWorkflowApproverStaff<TData = Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError = AxiosError<unknown>>(
 params: SearchWorkflowApproverStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchWorkflowApproverStaff>>,
          TError,
          Awaited<ReturnType<typeof searchWorkflowApproverStaff>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchWorkflowApproverStaff<TData = Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError = AxiosError<unknown>>(
 params: SearchWorkflowApproverStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search MIS staff for workflow approver selection
 */

export function useSearchWorkflowApproverStaff<TData = Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError = AxiosError<unknown>>(
 params: SearchWorkflowApproverStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWorkflowApproverStaff>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchWorkflowApproverStaffQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAllGuestHouses = (
    params?: GetAllGuestHousesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseGuestHouseResponse>> => {
    
    
    return axios.default.get(
      `/api/guesthouse`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllGuestHousesQueryKey = (params?: GetAllGuestHousesParams,) => {
    return [
    `/api/guesthouse`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllGuestHousesQueryOptions = <TData = Awaited<ReturnType<typeof getAllGuestHouses>>, TError = AxiosError<unknown>>(params?: GetAllGuestHousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestHouses>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllGuestHousesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllGuestHouses>>> = ({ signal }) => getAllGuestHouses(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllGuestHouses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllGuestHousesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllGuestHouses>>>
export type GetAllGuestHousesQueryError = AxiosError<unknown>


export function useGetAllGuestHouses<TData = Awaited<ReturnType<typeof getAllGuestHouses>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllGuestHousesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestHouses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGuestHouses>>,
          TError,
          Awaited<ReturnType<typeof getAllGuestHouses>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllGuestHouses<TData = Awaited<ReturnType<typeof getAllGuestHouses>>, TError = AxiosError<unknown>>(
 params?: GetAllGuestHousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestHouses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGuestHouses>>,
          TError,
          Awaited<ReturnType<typeof getAllGuestHouses>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllGuestHouses<TData = Awaited<ReturnType<typeof getAllGuestHouses>>, TError = AxiosError<unknown>>(
 params?: GetAllGuestHousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestHouses>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllGuestHouses<TData = Awaited<ReturnType<typeof getAllGuestHouses>>, TError = AxiosError<unknown>>(
 params?: GetAllGuestHousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGuestHouses>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllGuestHousesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGuestHouseById = (
    guestHouseId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestHouseResponse>> => {
    
    
    return axios.default.get(
      `/api/guesthouse/${guestHouseId}`,options
    );
  }




export const getGetGuestHouseByIdQueryKey = (guestHouseId?: number,) => {
    return [
    `/api/guesthouse/${guestHouseId}`
    ] as const;
    }

    
export const getGetGuestHouseByIdQueryOptions = <TData = Awaited<ReturnType<typeof getGuestHouseById>>, TError = AxiosError<unknown>>(guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestHouseByIdQueryKey(guestHouseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestHouseById>>> = ({ signal }) => getGuestHouseById(guestHouseId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(guestHouseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestHouseByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestHouseById>>>
export type GetGuestHouseByIdQueryError = AxiosError<unknown>


export function useGetGuestHouseById<TData = Awaited<ReturnType<typeof getGuestHouseById>>, TError = AxiosError<unknown>>(
 guestHouseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestHouseById>>,
          TError,
          Awaited<ReturnType<typeof getGuestHouseById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestHouseById<TData = Awaited<ReturnType<typeof getGuestHouseById>>, TError = AxiosError<unknown>>(
 guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestHouseById>>,
          TError,
          Awaited<ReturnType<typeof getGuestHouseById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestHouseById<TData = Awaited<ReturnType<typeof getGuestHouseById>>, TError = AxiosError<unknown>>(
 guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGuestHouseById<TData = Awaited<ReturnType<typeof getGuestHouseById>>, TError = AxiosError<unknown>>(
 guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestHouseByIdQueryOptions(guestHouseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getImageById = (
    imageId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestHouseImageResponse>> => {
    
    
    return axios.default.get(
      `/api/guesthouse/images/${imageId}`,options
    );
  }




export const getGetImageByIdQueryKey = (imageId?: number,) => {
    return [
    `/api/guesthouse/images/${imageId}`
    ] as const;
    }

    
export const getGetImageByIdQueryOptions = <TData = Awaited<ReturnType<typeof getImageById>>, TError = AxiosError<unknown>>(imageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImageByIdQueryKey(imageId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImageById>>> = ({ signal }) => getImageById(imageId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(imageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImageById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImageByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getImageById>>>
export type GetImageByIdQueryError = AxiosError<unknown>


export function useGetImageById<TData = Awaited<ReturnType<typeof getImageById>>, TError = AxiosError<unknown>>(
 imageId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageById>>,
          TError,
          Awaited<ReturnType<typeof getImageById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImageById<TData = Awaited<ReturnType<typeof getImageById>>, TError = AxiosError<unknown>>(
 imageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageById>>,
          TError,
          Awaited<ReturnType<typeof getImageById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImageById<TData = Awaited<ReturnType<typeof getImageById>>, TError = AxiosError<unknown>>(
 imageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetImageById<TData = Awaited<ReturnType<typeof getImageById>>, TError = AxiosError<unknown>>(
 imageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImageByIdQueryOptions(imageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteImage = (
    imageId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteImage200>> => {
    
    
    return axios.default.delete(
      `/api/guesthouse/images/${imageId}`,options
    );
  }



export const getDeleteImageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImage>>, TError,{imageId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImage>>, TError,{imageId: number}, TContext> => {

const mutationKey = ['deleteImage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImage>>, {imageId: number}> = (props) => {
          const {imageId} = props ?? {};

          return  deleteImage(imageId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImage>>>
    
    export type DeleteImageMutationError = AxiosError<unknown>

    export const useDeleteImage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImage>>, TError,{imageId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteImage>>,
        TError,
        {imageId: number},
        TContext
      > => {

      const mutationOptions = getDeleteImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getImageByIdAndGuestHouseId = (
    imageId: number,
    guestHouseId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestHouseImageResponse>> => {
    
    
    return axios.default.get(
      `/api/guesthouse/images/${imageId}/guesthouse/${guestHouseId}`,options
    );
  }




export const getGetImageByIdAndGuestHouseIdQueryKey = (imageId?: number,
    guestHouseId?: number,) => {
    return [
    `/api/guesthouse/images/${imageId}/guesthouse/${guestHouseId}`
    ] as const;
    }

    
export const getGetImageByIdAndGuestHouseIdQueryOptions = <TData = Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError = AxiosError<unknown>>(imageId: number,
    guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImageByIdAndGuestHouseIdQueryKey(imageId,guestHouseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>> = ({ signal }) => getImageByIdAndGuestHouseId(imageId,guestHouseId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(imageId && guestHouseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImageByIdAndGuestHouseIdQueryResult = NonNullable<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>>
export type GetImageByIdAndGuestHouseIdQueryError = AxiosError<unknown>


export function useGetImageByIdAndGuestHouseId<TData = Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError = AxiosError<unknown>>(
 imageId: number,
    guestHouseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>,
          TError,
          Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImageByIdAndGuestHouseId<TData = Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError = AxiosError<unknown>>(
 imageId: number,
    guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>,
          TError,
          Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImageByIdAndGuestHouseId<TData = Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError = AxiosError<unknown>>(
 imageId: number,
    guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetImageByIdAndGuestHouseId<TData = Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError = AxiosError<unknown>>(
 imageId: number,
    guestHouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageByIdAndGuestHouseId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImageByIdAndGuestHouseIdQueryOptions(imageId,guestHouseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGuestHouseImages = (
    guestHouseId: number,
    params?: GetGuestHouseImagesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseGuestHouseImageResponse>> => {
    
    
    return axios.default.get(
      `/api/guesthouse/images/guesthouse/${guestHouseId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetGuestHouseImagesQueryKey = (guestHouseId?: number,
    params?: GetGuestHouseImagesParams,) => {
    return [
    `/api/guesthouse/images/guesthouse/${guestHouseId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetGuestHouseImagesQueryOptions = <TData = Awaited<ReturnType<typeof getGuestHouseImages>>, TError = AxiosError<unknown>>(guestHouseId: number,
    params?: GetGuestHouseImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseImages>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestHouseImagesQueryKey(guestHouseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestHouseImages>>> = ({ signal }) => getGuestHouseImages(guestHouseId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(guestHouseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseImages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestHouseImagesQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestHouseImages>>>
export type GetGuestHouseImagesQueryError = AxiosError<unknown>


export function useGetGuestHouseImages<TData = Awaited<ReturnType<typeof getGuestHouseImages>>, TError = AxiosError<unknown>>(
 guestHouseId: number,
    params: undefined |  GetGuestHouseImagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseImages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestHouseImages>>,
          TError,
          Awaited<ReturnType<typeof getGuestHouseImages>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestHouseImages<TData = Awaited<ReturnType<typeof getGuestHouseImages>>, TError = AxiosError<unknown>>(
 guestHouseId: number,
    params?: GetGuestHouseImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseImages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestHouseImages>>,
          TError,
          Awaited<ReturnType<typeof getGuestHouseImages>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestHouseImages<TData = Awaited<ReturnType<typeof getGuestHouseImages>>, TError = AxiosError<unknown>>(
 guestHouseId: number,
    params?: GetGuestHouseImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseImages>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGuestHouseImages<TData = Awaited<ReturnType<typeof getGuestHouseImages>>, TError = AxiosError<unknown>>(
 guestHouseId: number,
    params?: GetGuestHouseImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestHouseImages>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestHouseImagesQueryOptions(guestHouseId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGuestById = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Guest>> => {
    
    
    return axios.default.get(
      `/api/guest/${id}`,options
    );
  }




export const getGetGuestByIdQueryKey = (id?: number,) => {
    return [
    `/api/guest/${id}`
    ] as const;
    }

    
export const getGetGuestByIdQueryOptions = <TData = Awaited<ReturnType<typeof getGuestById>>, TError = AxiosError<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestById>>> = ({ signal }) => getGuestById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestById>>>
export type GetGuestByIdQueryError = AxiosError<unknown>


export function useGetGuestById<TData = Awaited<ReturnType<typeof getGuestById>>, TError = AxiosError<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestById>>,
          TError,
          Awaited<ReturnType<typeof getGuestById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestById<TData = Awaited<ReturnType<typeof getGuestById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestById>>,
          TError,
          Awaited<ReturnType<typeof getGuestById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestById<TData = Awaited<ReturnType<typeof getGuestById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGuestById<TData = Awaited<ReturnType<typeof getGuestById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteGuest = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/guest/${id}`,options
    );
  }



export const getDeleteGuestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuest>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGuest>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteGuest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGuest>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteGuest(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGuestMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGuest>>>
    
    export type DeleteGuestMutationError = AxiosError<unknown>

    export const useDeleteGuest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuest>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGuest>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteGuestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGuestByUserId = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Guest>> => {
    
    
    return axios.default.get(
      `/api/guest/user/${userId}`,options
    );
  }




export const getGetGuestByUserIdQueryKey = (userId?: number,) => {
    return [
    `/api/guest/user/${userId}`
    ] as const;
    }

    
export const getGetGuestByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getGuestByUserId>>, TError = AxiosError<unknown>>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestByUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestByUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestByUserId>>> = ({ signal }) => getGuestByUserId(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestByUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestByUserId>>>
export type GetGuestByUserIdQueryError = AxiosError<unknown>


export function useGetGuestByUserId<TData = Awaited<ReturnType<typeof getGuestByUserId>>, TError = AxiosError<unknown>>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestByUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestByUserId>>,
          TError,
          Awaited<ReturnType<typeof getGuestByUserId>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestByUserId<TData = Awaited<ReturnType<typeof getGuestByUserId>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestByUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestByUserId>>,
          TError,
          Awaited<ReturnType<typeof getGuestByUserId>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestByUserId<TData = Awaited<ReturnType<typeof getGuestByUserId>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestByUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGuestByUserId<TData = Awaited<ReturnType<typeof getGuestByUserId>>, TError = AxiosError<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestByUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestByUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGuestInfoById = (
    guestInfoId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GuestInfo>> => {
    
    
    return axios.default.get(
      `/api/guest-info/${guestInfoId}`,options
    );
  }




export const getGetGuestInfoByIdQueryKey = (guestInfoId?: number,) => {
    return [
    `/api/guest-info/${guestInfoId}`
    ] as const;
    }

    
export const getGetGuestInfoByIdQueryOptions = <TData = Awaited<ReturnType<typeof getGuestInfoById>>, TError = AxiosError<unknown>>(guestInfoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestInfoById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestInfoByIdQueryKey(guestInfoId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestInfoById>>> = ({ signal }) => getGuestInfoById(guestInfoId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(guestInfoId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestInfoById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestInfoByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestInfoById>>>
export type GetGuestInfoByIdQueryError = AxiosError<unknown>


export function useGetGuestInfoById<TData = Awaited<ReturnType<typeof getGuestInfoById>>, TError = AxiosError<unknown>>(
 guestInfoId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestInfoById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestInfoById>>,
          TError,
          Awaited<ReturnType<typeof getGuestInfoById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestInfoById<TData = Awaited<ReturnType<typeof getGuestInfoById>>, TError = AxiosError<unknown>>(
 guestInfoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestInfoById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestInfoById>>,
          TError,
          Awaited<ReturnType<typeof getGuestInfoById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestInfoById<TData = Awaited<ReturnType<typeof getGuestInfoById>>, TError = AxiosError<unknown>>(
 guestInfoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestInfoById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGuestInfoById<TData = Awaited<ReturnType<typeof getGuestInfoById>>, TError = AxiosError<unknown>>(
 guestInfoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestInfoById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestInfoByIdQueryOptions(guestInfoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns all active food item categories for use in food item forms and filters.
 * @summary List food item categories
 */
export const getCategories = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FoodItemCategoryDto[]>> => {
    
    
    return axios.default.get(
      `/api/categories`,options
    );
  }




export const getGetCategoriesQueryKey = () => {
    return [
    `/api/categories`
    ] as const;
    }

    
export const getGetCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getCategories>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategories>>> = ({ signal }) => getCategories({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getCategories>>>
export type GetCategoriesQueryError = AxiosError<unknown>


export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List food item categories
 */

export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAllBookings = (
    params?: GetAllBookingsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseBookingDetails>> => {
    
    
    return axios.default.get(
      `/api/bookings`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllBookingsQueryKey = (params?: GetAllBookingsParams,) => {
    return [
    `/api/bookings`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getAllBookings>>, TError = AxiosError<unknown>>(params?: GetAllBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBookings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllBookingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllBookings>>> = ({ signal }) => getAllBookings(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllBookings>>>
export type GetAllBookingsQueryError = AxiosError<unknown>


export function useGetAllBookings<TData = Awaited<ReturnType<typeof getAllBookings>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllBookingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBookings>>,
          TError,
          Awaited<ReturnType<typeof getAllBookings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllBookings<TData = Awaited<ReturnType<typeof getAllBookings>>, TError = AxiosError<unknown>>(
 params?: GetAllBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBookings>>,
          TError,
          Awaited<ReturnType<typeof getAllBookings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllBookings<TData = Awaited<ReturnType<typeof getAllBookings>>, TError = AxiosError<unknown>>(
 params?: GetAllBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBookings>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllBookings<TData = Awaited<ReturnType<typeof getAllBookings>>, TError = AxiosError<unknown>>(
 params?: GetAllBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBookings>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllBookingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGuestBookings = (
    guestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BookingDetails[]>> => {
    
    
    return axios.default.get(
      `/api/bookings/${guestId}/bookings`,options
    );
  }




export const getGetGuestBookingsQueryKey = (guestId?: number,) => {
    return [
    `/api/bookings/${guestId}/bookings`
    ] as const;
    }

    
export const getGetGuestBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getGuestBookings>>, TError = AxiosError<unknown>>(guestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestBookings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestBookingsQueryKey(guestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestBookings>>> = ({ signal }) => getGuestBookings(guestId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(guestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestBookings>>>
export type GetGuestBookingsQueryError = AxiosError<unknown>


export function useGetGuestBookings<TData = Awaited<ReturnType<typeof getGuestBookings>>, TError = AxiosError<unknown>>(
 guestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestBookings>>,
          TError,
          Awaited<ReturnType<typeof getGuestBookings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestBookings<TData = Awaited<ReturnType<typeof getGuestBookings>>, TError = AxiosError<unknown>>(
 guestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestBookings>>,
          TError,
          Awaited<ReturnType<typeof getGuestBookings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestBookings<TData = Awaited<ReturnType<typeof getGuestBookings>>, TError = AxiosError<unknown>>(
 guestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestBookings>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGuestBookings<TData = Awaited<ReturnType<typeof getGuestBookings>>, TError = AxiosError<unknown>>(
 guestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestBookings>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestBookingsQueryOptions(guestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getBookingById = (
    bookingId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BookingDetails>> => {
    
    
    return axios.default.get(
      `/api/bookings/${bookingId}`,options
    );
  }




export const getGetBookingByIdQueryKey = (bookingId?: number,) => {
    return [
    `/api/bookings/${bookingId}`
    ] as const;
    }

    
export const getGetBookingByIdQueryOptions = <TData = Awaited<ReturnType<typeof getBookingById>>, TError = AxiosError<unknown>>(bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingByIdQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingById>>> = ({ signal }) => getBookingById(bookingId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingById>>>
export type GetBookingByIdQueryError = AxiosError<unknown>


export function useGetBookingById<TData = Awaited<ReturnType<typeof getBookingById>>, TError = AxiosError<unknown>>(
 bookingId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingById>>,
          TError,
          Awaited<ReturnType<typeof getBookingById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingById<TData = Awaited<ReturnType<typeof getBookingById>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingById>>,
          TError,
          Awaited<ReturnType<typeof getBookingById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingById<TData = Awaited<ReturnType<typeof getBookingById>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBookingById<TData = Awaited<ReturnType<typeof getBookingById>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingByIdQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteBooking = (
    bookingId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteBooking200>> => {
    
    
    return axios.default.delete(
      `/api/bookings/${bookingId}`,options
    );
  }



export const getDeleteBookingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBooking>>, TError,{bookingId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBooking>>, TError,{bookingId: number}, TContext> => {

const mutationKey = ['deleteBooking'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBooking>>, {bookingId: number}> = (props) => {
          const {bookingId} = props ?? {};

          return  deleteBooking(bookingId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBookingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBooking>>>
    
    export type DeleteBookingMutationError = AxiosError<unknown>

    export const useDeleteBooking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBooking>>, TError,{bookingId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBooking>>,
        TError,
        {bookingId: number},
        TContext
      > => {

      const mutationOptions = getDeleteBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const calculateBookingPrice = (
    bookingId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceDTO>> => {
    
    
    return axios.default.get(
      `/api/bookings/${bookingId}/price`,options
    );
  }




export const getCalculateBookingPriceQueryKey = (bookingId?: number,) => {
    return [
    `/api/bookings/${bookingId}/price`
    ] as const;
    }

    
export const getCalculateBookingPriceQueryOptions = <TData = Awaited<ReturnType<typeof calculateBookingPrice>>, TError = AxiosError<unknown>>(bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateBookingPrice>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateBookingPriceQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateBookingPrice>>> = ({ signal }) => calculateBookingPrice(bookingId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calculateBookingPrice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalculateBookingPriceQueryResult = NonNullable<Awaited<ReturnType<typeof calculateBookingPrice>>>
export type CalculateBookingPriceQueryError = AxiosError<unknown>


export function useCalculateBookingPrice<TData = Awaited<ReturnType<typeof calculateBookingPrice>>, TError = AxiosError<unknown>>(
 bookingId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateBookingPrice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateBookingPrice>>,
          TError,
          Awaited<ReturnType<typeof calculateBookingPrice>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalculateBookingPrice<TData = Awaited<ReturnType<typeof calculateBookingPrice>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateBookingPrice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateBookingPrice>>,
          TError,
          Awaited<ReturnType<typeof calculateBookingPrice>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalculateBookingPrice<TData = Awaited<ReturnType<typeof calculateBookingPrice>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateBookingPrice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCalculateBookingPrice<TData = Awaited<ReturnType<typeof calculateBookingPrice>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateBookingPrice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalculateBookingPriceQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getBookingGuests = (
    bookingId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBookingGuests200>> => {
    
    
    return axios.default.get(
      `/api/bookings/${bookingId}/guests`,options
    );
  }




export const getGetBookingGuestsQueryKey = (bookingId?: number,) => {
    return [
    `/api/bookings/${bookingId}/guests`
    ] as const;
    }

    
export const getGetBookingGuestsQueryOptions = <TData = Awaited<ReturnType<typeof getBookingGuests>>, TError = AxiosError<unknown>>(bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingGuests>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingGuestsQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingGuests>>> = ({ signal }) => getBookingGuests(bookingId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingGuests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingGuestsQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingGuests>>>
export type GetBookingGuestsQueryError = AxiosError<unknown>


export function useGetBookingGuests<TData = Awaited<ReturnType<typeof getBookingGuests>>, TError = AxiosError<unknown>>(
 bookingId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingGuests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingGuests>>,
          TError,
          Awaited<ReturnType<typeof getBookingGuests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingGuests<TData = Awaited<ReturnType<typeof getBookingGuests>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingGuests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingGuests>>,
          TError,
          Awaited<ReturnType<typeof getBookingGuests>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingGuests<TData = Awaited<ReturnType<typeof getBookingGuests>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingGuests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBookingGuests<TData = Awaited<ReturnType<typeof getBookingGuests>>, TError = AxiosError<unknown>>(
 bookingId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingGuests>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingGuestsQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download CSV or Excel template for booking/reservation data upload
 * @summary Download booking upload template
 */
export const downloadTemplate1 = (
    params?: DownloadTemplate1Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DownloadTemplate1200>> => {
    
    
    return axios.default.get(
      `/api/bookings/download-template`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getDownloadTemplate1QueryKey = (params?: DownloadTemplate1Params,) => {
    return [
    `/api/bookings/download-template`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDownloadTemplate1QueryOptions = <TData = Awaited<ReturnType<typeof downloadTemplate1>>, TError = AxiosError<unknown>>(params?: DownloadTemplate1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate1>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadTemplate1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTemplate1>>> = ({ signal }) => downloadTemplate1(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadTemplate1QueryResult = NonNullable<Awaited<ReturnType<typeof downloadTemplate1>>>
export type DownloadTemplate1QueryError = AxiosError<unknown>


export function useDownloadTemplate1<TData = Awaited<ReturnType<typeof downloadTemplate1>>, TError = AxiosError<unknown>>(
 params: undefined |  DownloadTemplate1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTemplate1>>,
          TError,
          Awaited<ReturnType<typeof downloadTemplate1>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTemplate1<TData = Awaited<ReturnType<typeof downloadTemplate1>>, TError = AxiosError<unknown>>(
 params?: DownloadTemplate1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTemplate1>>,
          TError,
          Awaited<ReturnType<typeof downloadTemplate1>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTemplate1<TData = Awaited<ReturnType<typeof downloadTemplate1>>, TError = AxiosError<unknown>>(
 params?: DownloadTemplate1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download booking upload template
 */

export function useDownloadTemplate1<TData = Awaited<ReturnType<typeof downloadTemplate1>>, TError = AxiosError<unknown>>(
 params?: DownloadTemplate1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTemplate1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadTemplate1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAvailableRooms = (
    params: GetAvailableRoomsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RoomResponse[]>> => {
    
    
    return axios.default.get(
      `/api/bookings/available-rooms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAvailableRoomsQueryKey = (params?: GetAvailableRoomsParams,) => {
    return [
    `/api/bookings/available-rooms`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAvailableRoomsQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableRooms>>, TError = AxiosError<unknown>>(params: GetAvailableRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableRooms>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableRoomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableRooms>>> = ({ signal }) => getAvailableRooms(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableRooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableRooms>>>
export type GetAvailableRoomsQueryError = AxiosError<unknown>


export function useGetAvailableRooms<TData = Awaited<ReturnType<typeof getAvailableRooms>>, TError = AxiosError<unknown>>(
 params: GetAvailableRoomsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableRooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableRooms>>,
          TError,
          Awaited<ReturnType<typeof getAvailableRooms>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableRooms<TData = Awaited<ReturnType<typeof getAvailableRooms>>, TError = AxiosError<unknown>>(
 params: GetAvailableRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableRooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableRooms>>,
          TError,
          Awaited<ReturnType<typeof getAvailableRooms>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableRooms<TData = Awaited<ReturnType<typeof getAvailableRooms>>, TError = AxiosError<unknown>>(
 params: GetAvailableRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableRooms>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableRooms<TData = Awaited<ReturnType<typeof getAvailableRooms>>, TError = AxiosError<unknown>>(
 params: GetAvailableRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableRooms>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableRoomsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAllAmenities = (
    params?: GetAllAmenitiesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PagedResponseAmenity>> => {
    
    
    return axios.default.get(
      `/api/amenity`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllAmenitiesQueryKey = (params?: GetAllAmenitiesParams,) => {
    return [
    `/api/amenity`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllAmenitiesQueryOptions = <TData = Awaited<ReturnType<typeof getAllAmenities>>, TError = AxiosError<unknown>>(params?: GetAllAmenitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAmenities>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAmenitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAmenities>>> = ({ signal }) => getAllAmenities(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAmenities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllAmenitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAmenities>>>
export type GetAllAmenitiesQueryError = AxiosError<unknown>


export function useGetAllAmenities<TData = Awaited<ReturnType<typeof getAllAmenities>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllAmenitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAmenities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAmenities>>,
          TError,
          Awaited<ReturnType<typeof getAllAmenities>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllAmenities<TData = Awaited<ReturnType<typeof getAllAmenities>>, TError = AxiosError<unknown>>(
 params?: GetAllAmenitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAmenities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAmenities>>,
          TError,
          Awaited<ReturnType<typeof getAllAmenities>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllAmenities<TData = Awaited<ReturnType<typeof getAllAmenities>>, TError = AxiosError<unknown>>(
 params?: GetAllAmenitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAmenities>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllAmenities<TData = Awaited<ReturnType<typeof getAllAmenities>>, TError = AxiosError<unknown>>(
 params?: GetAllAmenitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAmenities>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllAmenitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAmenityById = (
    amenityId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Amenity>> => {
    
    
    return axios.default.get(
      `/api/amenity/${amenityId}`,options
    );
  }




export const getGetAmenityByIdQueryKey = (amenityId?: number,) => {
    return [
    `/api/amenity/${amenityId}`
    ] as const;
    }

    
export const getGetAmenityByIdQueryOptions = <TData = Awaited<ReturnType<typeof getAmenityById>>, TError = AxiosError<unknown>>(amenityId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAmenityById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAmenityByIdQueryKey(amenityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAmenityById>>> = ({ signal }) => getAmenityById(amenityId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(amenityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAmenityById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAmenityByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAmenityById>>>
export type GetAmenityByIdQueryError = AxiosError<unknown>


export function useGetAmenityById<TData = Awaited<ReturnType<typeof getAmenityById>>, TError = AxiosError<unknown>>(
 amenityId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAmenityById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAmenityById>>,
          TError,
          Awaited<ReturnType<typeof getAmenityById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAmenityById<TData = Awaited<ReturnType<typeof getAmenityById>>, TError = AxiosError<unknown>>(
 amenityId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAmenityById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAmenityById>>,
          TError,
          Awaited<ReturnType<typeof getAmenityById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAmenityById<TData = Awaited<ReturnType<typeof getAmenityById>>, TError = AxiosError<unknown>>(
 amenityId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAmenityById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAmenityById<TData = Awaited<ReturnType<typeof getAmenityById>>, TError = AxiosError<unknown>>(
 amenityId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAmenityById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAmenityByIdQueryOptions(amenityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteServiceBreakdown = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteServiceBreakdown200>> => {
    
    
    return axios.default.delete(
      `/api/servicebreakdown/${id}`,options
    );
  }



export const getDeleteServiceBreakdownMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceBreakdown>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceBreakdown>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteServiceBreakdown'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceBreakdown>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceBreakdown(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceBreakdownMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceBreakdown>>>
    
    export type DeleteServiceBreakdownMutationError = AxiosError<unknown>

    export const useDeleteServiceBreakdown = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceBreakdown>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceBreakdown>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteServiceBreakdownMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteServiceAddOn = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteServiceAddOn200>> => {
    
    
    return axios.default.delete(
      `/api/service-add-on/${id}`,options
    );
  }



export const getDeleteServiceAddOnMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAddOn>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAddOn>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteServiceAddOn'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceAddOn>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceAddOn(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceAddOnMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceAddOn>>>
    
    export type DeleteServiceAddOnMutationError = AxiosError<unknown>

    export const useDeleteServiceAddOn = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAddOn>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceAddOn>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteServiceAddOnMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteRate = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteRate200>> => {
    
    
    return axios.default.delete(
      `/api/rate/${id}`,options
    );
  }



export const getDeleteRateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRate>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteRate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRate(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRate>>>
    
    export type DeleteRateMutationError = AxiosError<unknown>

    export const useDeleteRate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRate>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteRateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteGuestHouse = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteGuestHouse200>> => {
    
    
    return axios.default.delete(
      `/api/guesthouse/${id}`,options
    );
  }



export const getDeleteGuestHouseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuestHouse>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGuestHouse>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteGuestHouse'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGuestHouse>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteGuestHouse(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGuestHouseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGuestHouse>>>
    
    export type DeleteGuestHouseMutationError = AxiosError<unknown>

    export const useDeleteGuestHouse = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuestHouse>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGuestHouse>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteGuestHouseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteGuestInfo = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteGuestInfo200>> => {
    
    
    return axios.default.delete(
      `/api/guest-info/${id}`,options
    );
  }



export const getDeleteGuestInfoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuestInfo>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGuestInfo>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteGuestInfo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGuestInfo>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteGuestInfo(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGuestInfoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGuestInfo>>>
    
    export type DeleteGuestInfoMutationError = AxiosError<unknown>

    export const useDeleteGuestInfo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuestInfo>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGuestInfo>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteGuestInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const removeGuestFromBooking = (
    bookingId: number,
    guestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RemoveGuestFromBooking200>> => {
    
    
    return axios.default.delete(
      `/api/bookings/${bookingId}/guests/${guestId}`,options
    );
  }



export const getRemoveGuestFromBookingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeGuestFromBooking>>, TError,{bookingId: number;guestId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeGuestFromBooking>>, TError,{bookingId: number;guestId: number}, TContext> => {

const mutationKey = ['removeGuestFromBooking'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeGuestFromBooking>>, {bookingId: number;guestId: number}> = (props) => {
          const {bookingId,guestId} = props ?? {};

          return  removeGuestFromBooking(bookingId,guestId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveGuestFromBookingMutationResult = NonNullable<Awaited<ReturnType<typeof removeGuestFromBooking>>>
    
    export type RemoveGuestFromBookingMutationError = AxiosError<unknown>

    export const useRemoveGuestFromBooking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeGuestFromBooking>>, TError,{bookingId: number;guestId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeGuestFromBooking>>,
        TError,
        {bookingId: number;guestId: number},
        TContext
      > => {

      const mutationOptions = getRemoveGuestFromBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteAmenity = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteAmenity200>> => {
    
    
    return axios.default.delete(
      `/api/amenity/${id}`,options
    );
  }



export const getDeleteAmenityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAmenity>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAmenity>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAmenity'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAmenity>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAmenity(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAmenityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAmenity>>>
    
    export type DeleteAmenityMutationError = AxiosError<unknown>

    export const useDeleteAmenity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAmenity>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAmenity>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteAmenityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
